import { jsx as x, jsxs as V, Fragment as mn } from "react/jsx-runtime";
import oi, { useId as ai, useState as Q, useRef as ve, useEffect as Se } from "react";
import { adjustTooltipPosition as pn, translateToNotScaled as Ct, SciChartSurface as ge, SciChartJSLightTheme as li, Thickness as j, ELabelAlignment as st, NumberRange as N, EAutoRange as z, EAxisAlignment as re, DateTimeNumericAxis as ci, NumericAxis as xe, EAnnotationLayer as ee, EDraggingGripPoint as di, VerticalLineAnnotation as ui, ECoordinateMode as D, CustomAnnotation as Ae, EVerticalAnchorPoint as te, EHorizontalAnchorPoint as we, HorizontalLineAnnotation as fi, StackedColumnCollection as bn, EDataPointWidthMode as gn, XyDataSeries as le, StackedColumnRenderableSeries as xn, CursorModifier as hi, EMultiLineAlignment as He, TextLabelProvider as mi, XyScatterRenderableSeries as ht, RubberBandXyZoomModifier as pi, ZoomPanModifier as bi, BoxAnnotation as It, FastLineRenderableSeries as yn, MouseWheelZoomModifier as vn, ZoomExtentsModifier as Sn, EllipsePointMarker as mt, XPointMarker as gi, TrianglePointMarker as xi, SquarePointMarker as yi, CrossPointMarker as vi, ChartModifierBase2D as Si, EXyDirection as Xe, SciChartDefaults as Mt } from "scichart";
import { Checkbox as An, Skeleton as G } from "@assetwatch/ui";
import { libraryVersion as Lt } from "scichart/Core/BuildStamp";
var Me = { exports: {} }, Ze = {};
/**
 * @license React
 * react-compiler-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _t;
function wn() {
  if (_t) return Ze;
  _t = 1;
  var t = oi.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  return Ze.c = function(e) {
    return t.H.useMemoCache(e);
  }, Ze;
}
var Ye = {};
/**
 * @license React
 * react-compiler-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $t;
function Rn() {
  return $t || ($t = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = oi.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    Ye.c = function(e) {
      var i = t.H;
      return i === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), i.useMemoCache(e);
    };
  })()), Ye;
}
var Pt;
function Tn() {
  return Pt || (Pt = 1, process.env.NODE_ENV === "production" ? Me.exports = wn() : Me.exports = Rn()), Me.exports;
}
var E = Tn();
const Nt = ["series-1", "series-2", "series-3", "series-4", "series-5", "series-6"], Ai = {
  "series-1": "bg-chart-series-1",
  "series-2": "bg-chart-series-2",
  "series-3": "bg-chart-series-3",
  "series-4": "bg-chart-series-4",
  "series-5": "bg-chart-series-5",
  "series-6": "bg-chart-series-6"
}, kn = {
  "series-1": "bg-chart-sequential-series-1",
  "series-2": "bg-chart-sequential-series-2",
  "series-3": "bg-chart-sequential-series-3",
  "series-4": "bg-chart-sequential-series-4",
  "series-5": "bg-chart-series-5",
  "series-6": "bg-chart-series-6"
}, H = {
  qualitative1: "--datavis-datavis-qual-color1",
  qualitative2: "--datavis-datavis-qual-color2",
  qualitative3: "--datavis-datavis-qual-color3",
  qualitative4: "--datavis-datavis-qual-color4",
  qualitative5: "--datavis-datavis-qual-color5",
  qualitative6: "--datavis-datavis-qual-color6",
  sequential1: "--datavis-datavis-seq-color1",
  sequential2: "--datavis-datavis-seq-color2",
  sequential3: "--datavis-datavis-seq-color3",
  sequential4: "--datavis-datavis-seq-color4",
  criticalRed: "--datavis-datavis-crit-red",
  criticalYellow: "--datavis-datavis-crit-yellow",
  criticalGreen: "--datavis-datavis-crit-green",
  clickedData: "--datavis-datavis-clicked-data",
  harmonics: "--datavis-datavis-harmonics"
}, Ge = {
  "series-1": H.qualitative1,
  "series-2": H.qualitative2,
  "series-3": H.qualitative3,
  "series-4": H.qualitative4,
  "series-5": H.qualitative5,
  "series-6": H.qualitative6
}, Cn = {
  "series-1": H.sequential4,
  "series-2": H.sequential3,
  "series-3": H.sequential2,
  "series-4": H.sequential1,
  "series-5": H.qualitative5,
  "series-6": H.qualitative6
};
function In(t, e = "qualitative") {
  return e === "sequential" ? kn[t] : Ai[t];
}
function wi(t, e = "qualitative") {
  return e === "sequential" ? Cn[t] : Ge[t];
}
const Ve = "currentColor";
function I(t) {
  if (typeof window > "u")
    return Ve;
  const e = ie(t);
  return e ? Ln(e) : Ve;
}
function Mn(t) {
  return typeof window > "u" ? "1" : ie(t).match(/\/\s*([\d.]+)/)?.[1] ?? "1";
}
function ie(t, e = /* @__PURE__ */ new Set()) {
  return e.has(t) ? "" : (e.add(t), getComputedStyle(document.documentElement).getPropertyValue(t).trim().replaceAll(/var\((--[\w-]+)(?:,\s*([^)]+))?\)/g, (n, r, s) => ie(r, e) || s?.trim() || "").trim());
}
function Ln(t) {
  const e = t.trim();
  if (e.startsWith("#") || e.startsWith("rgb(") || e.startsWith("rgba("))
    return e;
  const n = (e.startsWith("hsl(") ? e.slice(4, -1).trim() : e).replaceAll(",", " ").split(/\s+/).filter(Boolean).map((f) => f.replace("%", "")), r = n.indexOf("/");
  if (n.length < 3)
    return Ve;
  const s = Number(n[0]), o = Number(n[1]), a = Number(n[2]);
  if (!Number.isFinite(s) || !Number.isFinite(o) || !Number.isFinite(a))
    return Ve;
  const [c, d, l] = _n(s, o / 100, a / 100), u = r >= 0 ? Number(n[r + 1]) : 1;
  return Number.isFinite(u) && u < 1 ? `rgba(${c}, ${d}, ${l}, ${u})` : `#${Je(c)}${Je(d)}${Je(l)}`;
}
function _n(t, e, i) {
  const n = (1 - Math.abs(2 * i - 1)) * e, r = (t % 360 + 360) % 360 / 60, s = n * (1 - Math.abs(r % 2 - 1)), o = i - n / 2, [a, c, d] = $n(r, n, s);
  return [Math.round((a + o) * 255), Math.round((c + o) * 255), Math.round((d + o) * 255)];
}
function $n(t, e, i) {
  return t < 1 ? [e, i, 0] : t < 2 ? [i, e, 0] : t < 3 ? [0, e, i] : t < 4 ? [0, i, e] : t < 5 ? [i, 0, e] : [e, 0, i];
}
function Je(t) {
  return Math.max(0, Math.min(255, t)).toString(16).padStart(2, "0");
}
const Pn = 6, Et = "circle";
function je(t, e) {
  return Nt[e % Nt.length];
}
function Ri(t, e) {
  const i = t.pointMarkers ?? e;
  return typeof i == "object" ? i.type ?? Et : Et;
}
function Nn(t) {
  const e = t.filter((i) => i.initiallyVisible !== !1).map((i) => i.id);
  return e.length > 0 ? e : t.length > 0 ? [t[0].id] : [];
}
function En(t, e) {
  return e.includes(t) === !1 || e.length > 1;
}
function Dn(t, e) {
  const i = e.includes(t);
  return i && e.length === 1 ? [...e] : i ? e.filter((n) => n !== t) : [...e, t];
}
function Vn(t, e) {
  const i = new Set(e);
  return t.flatMap((n, r) => i.has(n.id) ? [{
    ...n,
    color: je(n, r)
  }] : []);
}
function zn(t) {
  return t.map((e, i) => ({
    ...e,
    color: je(e, i)
  }));
}
function Fn(t) {
  const e = [], i = /* @__PURE__ */ new Set();
  t.length > Pn && e.push("Data Charts support up to 6 visible series.");
  for (const n of t)
    n.id.trim() || e.push("Each chart series requires a non-empty id."), n.label.trim() || e.push(`Chart series "${n.id}" requires a non-empty label.`), i.has(n.id) && e.push(`Duplicate chart series id "${n.id}".`), i.add(n.id);
  return e;
}
function M(t) {
  return t instanceof Date ? t.getTime() / 1e3 : t;
}
function On(t, e) {
  const i = Number.isInteger(t) ? t.toLocaleString() : t.toLocaleString(void 0, {
    maximumFractionDigits: 2
  });
  return e.valueUnit ? `${i} ${e.valueUnit}` : i;
}
function Dt(t) {
  const e = E.c(2), {
    children: i
  } = t;
  let n;
  return e[0] !== i ? (n = /* @__PURE__ */ x("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ x("p", { className: "font-(family-name:--font-family-body) text-(length:--font-size-body-md) leading-(--line-height-20) font-normal tracking-normal text-text-subtle", children: i }) }), e[0] = i, e[1] = n) : n = e[1], n;
}
const Bn = 220;
function pt(t) {
  const e = E.c(14), {
    children: i,
    emptyMessage: n,
    hasData: r,
    height: s,
    validationErrors: o
  } = t;
  let a;
  e[0] !== s ? (a = {
    height: s,
    minHeight: Bn
  }, e[0] = s, e[1] = a) : a = e[1];
  const c = o.length === 0 && i;
  let d;
  e[2] !== o[0] || e[3] !== o.length ? (d = o.length > 0 && /* @__PURE__ */ x(Dt, { children: o[0] }), e[2] = o[0], e[3] = o.length, e[4] = d) : d = e[4];
  let l;
  e[5] !== n || e[6] !== r || e[7] !== o.length ? (l = !r && o.length === 0 && /* @__PURE__ */ x(Dt, { children: n }), e[5] = n, e[6] = r, e[7] = o.length, e[8] = l) : l = e[8];
  let u;
  return e[9] !== a || e[10] !== c || e[11] !== d || e[12] !== l ? (u = /* @__PURE__ */ V("div", { className: "relative min-h-[220px] w-full overflow-hidden", style: a, children: [
    c,
    d,
    l
  ] }), e[9] = a, e[10] = c, e[11] = d, e[12] = l, e[13] = u) : u = e[13], u;
}
const Hn = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: !0
}), Vt = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "short"
}), Gn = new Intl.DateTimeFormat("en-US", {
  year: "numeric"
}), zt = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  hour12: !0,
  minute: "2-digit"
}), Ft = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  hour12: !0,
  minute: "2-digit",
  second: "2-digit"
});
function Ti(t) {
  const e = Hn.formatToParts(t), i = B(e, "month"), n = B(e, "day"), r = B(e, "hour"), s = B(e, "minute"), o = B(e, "second"), a = B(e, "dayPeriod");
  return `${i} ${n} ${r}:${s}:${o} ${a}`;
}
function ki(t, e) {
  return Ii(t, Ci(e));
}
function jn(t, e) {
  const i = Ci(e);
  return Ii(t, i === "multi-day" ? "multi-month" : i);
}
function Ci(t) {
  return t <= 10 ? "very-tight" : t <= 3600 ? "tight" : t <= 1440 * 60 ? "same-day" : t <= 2160 * 60 * 60 ? "multi-day" : "multi-month";
}
function Ii(t, e) {
  if (e === "very-tight") {
    const r = Ft.formatToParts(t), s = Le(r, {
      includeSeconds: !0
    }), o = t.getMilliseconds().toString().padStart(3, "0"), a = B(r, "dayPeriod");
    return `${s}.${o}
${a}`;
  }
  if (e === "tight") {
    const r = Ft.formatToParts(t), s = Le(r, {
      includeSeconds: !0
    }), o = B(r, "dayPeriod");
    return `${s}
${o}`;
  }
  if (e === "same-day") {
    const r = zt.formatToParts(t), s = Le(r), o = B(r, "dayPeriod");
    return `${s}
${o}`;
  }
  if (e === "multi-day") {
    const r = Vt.format(t), s = zt.formatToParts(t), o = Le(s), a = B(s, "dayPeriod");
    return `${r}
${o} ${a}`;
  }
  const i = Vt.format(t), n = Gn.format(t);
  return `${i}
${n}`;
}
function Le(t, e = {}) {
  const i = B(t, "hour"), n = B(t, "minute");
  if (e.includeSeconds) {
    const r = B(t, "second");
    return `${i}:${n}:${r}`;
  }
  return `${i}:${n}`;
}
function B(t, e) {
  return t.find((i) => i.type === e)?.value ?? "";
}
const fe = 4, he = 4, Ot = 2, ne = 8, Un = 14, me = 20, qn = "Inter, Arial, sans-serif", Wn = 7.4, Kn = 80, _e = 18;
function Mi({
  chartPointMarkers: t,
  colorScheme: e = "qualitative",
  markerTypeOverride: i,
  series: n,
  tooltipRef: r
}) {
  return (s, o) => {
    const a = Zn({
      series: n,
      seriesInfos: s,
      svgAnnotation: o,
      tooltip: r.current,
      colorScheme: e,
      chartPointMarkers: t,
      markerTypeOverride: i
    });
    if (a.length === 0)
      return "<svg></svg>";
    const c = Math.max(...a.map((R) => R.text.length)), d = Math.max(Kn, fe * 2 + ne + he + Math.ceil(c * Wn)), l = fe * 2 + a.length * me + Math.max(0, a.length - 1) * he, u = d + _e * 2, f = l + _e * 2;
    pn(u, f, o), Xn(u, f, o);
    const h = I("--datavis-datavis-tooltip-bg"), b = I("--text-text-default"), p = I("--surface-shadow"), m = Mn("--elevation-shadow-3"), g = _e, v = _e, y = v + fe + me, w = a.map((R, S) => {
      const L = y + S * (me + he) - 5, k = y + S * (me + he) - me / 2 - ne / 2;
      return `${Yn({
        cx: g + fe + ne / 2,
        cy: k + ne / 2,
        fill: R.color,
        size: ne,
        type: R.markerType
      })}
<text x="${g + fe + ne + he}" y="${L}" fill="${b}" font-family="${qn}" font-size="${Un}" font-weight="700">${tr(R.text)}</text>`;
    }).join("");
    return `<svg class="scichart__cursor-tooltip" width="${u}" height="${f}" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="assetwatch-chart-tooltip-shadow" x="-50%" y="-50%" width="200%" height="220%">
      <feDropShadow dx="0" dy="6" stdDeviation="6" flood-color="${p}" flood-opacity="${m}" />
    </filter>
  </defs>
  <rect x="${g}" y="${v}" width="${d}" height="${l}" rx="${Ot}" ry="${Ot}" fill="${h}" filter="url(#assetwatch-chart-tooltip-shadow)" />
  ${w}
</svg>`;
  };
}
function Xn(t, e, i) {
  const n = i.parentSurface?.seriesViewRect;
  if (!n)
    return;
  const r = Ct(n.width), s = Ct(n.height), o = i.x1, a = i.y1;
  if (!Number.isFinite(r) || !Number.isFinite(s) || !Number.isFinite(o) || !Number.isFinite(a))
    return;
  const c = 0, d = 0, l = Math.max(c, r - t), u = Math.max(d, s - e), f = o + i.xCoordShift, h = a + i.yCoordShift, b = Bt(f, c, l), p = Bt(h, d, u);
  i.xCoordShift += b - f, i.yCoordShift += p - h;
}
function Bt(t, e, i) {
  return Math.min(Math.max(t, e), i);
}
function Zn({
  series: t,
  seriesInfos: e,
  svgAnnotation: i,
  tooltip: n,
  colorScheme: r,
  chartPointMarkers: s,
  markerTypeOverride: o
}) {
  const a = new Set(t.map((l) => l.label)), c = e.filter((l) => l.isVisible && a.has(l.seriesName));
  return (n?.mode === "nearestSeries" ? Jn(c, i) : c).flatMap((l) => {
    const u = t.findIndex((g) => g.label === l.seriesName), f = t[u];
    if (!l.isVisible || !f)
      return [];
    const h = l.yValue, b = typeof h == "number" ? h : Number(h), p = Number.isFinite(b) && n?.formatValue ? n.formatValue(b, f) : l.formattedYValue;
    return [{
      color: I(wi(je(f, u), r)),
      markerType: o ?? Ri(f, s),
      text: `${f.label}: ${p}`
    }];
  });
}
function Yn({
  cx: t,
  cy: e,
  fill: i,
  size: n,
  type: r
}) {
  const s = n / 2;
  switch (r) {
    case "square":
      return `<rect x="${t - s}" y="${e - s}" width="${n}" height="${n}" fill="${i}" />`;
    case "triangle":
      return `<polygon points="${t},${e - s} ${t - s},${e + s} ${t + s},${e + s}" fill="${i}" />`;
    case "cross": {
      const a = n * 0.3 / 2;
      return `<path d="M${t - a},${e - s} L${t + a},${e - s} L${t + a},${e - a} L${t + s},${e - a} L${t + s},${e + a} L${t + a},${e + a} L${t + a},${e + s} L${t - a},${e + s} L${t - a},${e + a} L${t - s},${e + a} L${t - s},${e - a} L${t - a},${e - a} Z" fill="${i}" />`;
    }
    case "x": {
      const o = n * 0.28;
      return `<g stroke="${i}" stroke-width="${o}" stroke-linecap="round">
<line x1="${t - s}" y1="${e - s}" x2="${t + s}" y2="${e + s}" />
<line x1="${t + s}" y1="${e - s}" x2="${t - s}" y2="${e + s}" />
</g>`;
    }
    default:
      return `<circle cx="${t}" cy="${e}" r="${s}" fill="${i}" />`;
  }
}
function Jn(t, e) {
  const i = Qn(e);
  if (!i)
    return t;
  const n = t.filter((r) => r.isVisible && Number.isFinite(r.xCoordinate) && Number.isFinite(r.yCoordinate)).map((r) => ({
    distance: er(i, {
      x: r.xCoordinate,
      y: r.yCoordinate
    }),
    info: r
  })).sort((r, s) => r.distance - s.distance)[0]?.info;
  return n ? [n] : [];
}
function Qn(t) {
  const e = t.x1, i = t.y1;
  if (!(!Number.isFinite(e) || !Number.isFinite(i)))
    return {
      x: e,
      y: i
    };
}
function er(t, e) {
  return Math.hypot(t.x - e.x, t.y - e.y);
}
function tr(t) {
  return t.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&apos;");
}
const ir = "assetwatch-stacked-bars", nr = 0.8, rr = -8, Ht = 4, sr = 0.9, Li = 90, or = 0, ar = 4, lr = 0, cr = {
  dashDot: [10, 5, 2, 5],
  dotted: [2, 4],
  longDash: [12, 6],
  shortDash: [6, 4],
  solid: []
};
function dr({
  series: t,
  visibleSeriesIds: e,
  xAxis: i,
  yAxis: n,
  stripLines: r = [],
  tooltip: s,
  stacked: o,
  dataPointWidth: a = 0.56,
  colorScheme: c = "sequential",
  showAxisLabels: d = !0,
  showAxisTickLabels: l = !0
}) {
  const u = ai().replaceAll(":", ""), [f, h] = Q(null), b = ve(s);
  return b.current = s, Se(() => {
    let p = !1, m;
    async function g() {
      try {
        const v = await bt.create({
          chartId: u,
          config: {
            colorScheme: c,
            dataPointWidth: a,
            series: t,
            showAxisLabels: d,
            showAxisTickLabels: l,
            stacked: o,
            stripLines: r,
            tooltipRef: b,
            visibleSeriesIds: e,
            xAxis: i,
            yAxis: n
          }
        });
        if (p) {
          v.dispose();
          return;
        }
        m = v, h(null);
      } catch (v) {
        p || h(v instanceof Error ? v.message : "Unable to render chart");
      }
    }
    return g(), () => {
      p = !0, m?.dispose();
    };
  }, [u, c, a, t, d, l, o, r, e, i, n]), /* @__PURE__ */ V("div", { className: "relative h-full w-full", children: [
    /* @__PURE__ */ x("div", { id: u, className: "h-full w-full" }),
    f && /* @__PURE__ */ x("div", { className: "absolute inset-0 flex items-center justify-center bg-surface", children: /* @__PURE__ */ x("p", { className: "max-w-[320px] text-center font-(family-name:--font-family-body) text-(length:--font-size-body-sm) leading-(--line-height-16) font-normal tracking-normal text-text-subtle", children: f }) })
  ] });
}
class bt {
  constructor(e) {
    this.surface = e;
  }
  surface;
  static async create({
    chartId: e,
    config: i
  }) {
    const n = await ge.create(e, {
      freezeWhenOutOfView: !0,
      padding: new j(0, 4, 0, 4),
      theme: {
        ...new li(),
        sciChartBackground: "Transparent",
        loadingAnimationBackground: "Transparent",
        loadingAnimationForeground: I("--primary-primary")
      }
    }), r = new bt(n.sciChartSurface);
    return r.initialize(n.wasmContext, i), r;
  }
  dispose() {
    this.surface.delete();
  }
  initialize(e, i) {
    this.surface.background = "transparent", this.surface.suspendUpdates();
    try {
      ur({
        config: i,
        surface: this.surface,
        wasmContext: e
      }), fr({
        config: i,
        surface: this.surface
      }), hr({
        config: i,
        surface: this.surface,
        wasmContext: e
      }), mr({
        config: i,
        surface: this.surface
      });
    } finally {
      this.surface.resumeUpdates({
        invalidateOnResume: !0
      });
    }
  }
}
function ur({
  config: t,
  surface: e,
  wasmContext: i
}) {
  const n = I("--datavis-datavis-axis-lines"), r = I("--datavis-datavis-grid-lines"), s = pr(t.series), o = vr(t.series, t.xAxis), a = Sr(t), c = Ir(), d = Mr();
  e.viewportBorder = {
    borderBottom: 1,
    borderLeft: 1,
    color: n
  };
  const l = {
    axisAlignment: re.Bottom,
    axisTitle: t.showAxisLabels ? t.xAxis?.title : void 0,
    axisTitleStyle: Wt("bottom"),
    autoRange: z.Once,
    drawLabels: t.showAxisLabels,
    drawMajorBands: !1,
    drawMajorGridLines: !1,
    drawMajorTickLines: t.showAxisTickLabels,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: new N(0.08, 0.08),
    keepLabelsWithinAxis: !1,
    labelStyle: {
      ...c,
      alignment: st.Center,
      color: Kt(t.showAxisTickLabels)
    },
    majorTickLineStyle: Xt(n),
    maxAutoTicks: t.xAxis?.tickCount ?? 9,
    useNativeText: !1,
    visibleRange: o
  }, u = s ? new ci(i, l) : new xe(i, l);
  s && (u.labelProvider = new yr()), br({
    axis: u,
    hasDateAxis: s,
    xAxis: t.xAxis
  }), e.xAxes.add(u);
  const f = new xe(i, {
    axisAlignment: re.Left,
    axisTitle: t.showAxisLabels ? t.yAxis?.title : void 0,
    axisTitleStyle: Wt("left"),
    autoRange: a ? z.Never : z.Always,
    drawLabels: t.showAxisLabels,
    drawMajorBands: !1,
    drawMajorGridLines: !0,
    drawMajorTickLines: t.showAxisTickLabels,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: wr(t.yAxis),
    labelStyle: {
      ...d,
      color: Kt(t.showAxisTickLabels)
    },
    majorGridLineStyle: {
      color: r,
      strokeThickness: 1
    },
    majorTickLineStyle: Xt(n),
    maxAutoTicks: t.yAxis?.tickCount ?? 6,
    useNativeText: !1,
    visibleRange: a
  });
  gr({
    axis: f,
    yAxis: t.yAxis
  }), e.yAxes.add(f);
}
function fr({
  config: t,
  surface: e
}) {
  const i = I("--text-text-subtext"), n = Ue("--font-family-label"), r = qe("--font-size-label-medium", 12);
  t.stripLines.forEach((s) => {
    const o = s.layer === "behindData" ? ee.Background : ee.AboveChart, a = Cr(I(s.colorToken), nr), c = s.labelColor === "match" ? a : i, d = cr[s.lineStyle ?? "solid"], l = s.onDrag !== void 0, u = l ? [di.Body] : [];
    if (s.axis === "x") {
      const h = new ui({
        annotationLayer: o,
        dragPoints: u,
        isEditable: l,
        selectionBoxDelta: -1,
        selectionBoxStroke: "transparent",
        selectionBoxThickness: 0,
        showLabel: !1,
        stroke: a,
        strokeDashArray: d,
        strokeThickness: 1,
        x1: M(s.value),
        xCoordinateMode: D.DataValue
      });
      l && h.dragDelta.subscribe(() => {
        s.onDrag?.(s.value instanceof Date ? new Date(h.x1 * 1e3) : h.x1);
      }), e.annotations.add(h), s.label && e.annotations.add(new Ae({
        annotationLayer: o,
        horizontalAnchorPoint: we.Left,
        isEditable: !1,
        svgString: Ut({
          color: c,
          fontFamily: n,
          fontSize: r,
          rotation: Li,
          text: s.label
        }),
        verticalAnchorPoint: te.Top,
        x1: M(s.value),
        xCoordinateMode: D.DataValue,
        xCoordShift: or,
        y1: lr,
        yCoordShift: ar,
        yCoordinateMode: D.Relative
      }));
      return;
    }
    const f = new fi({
      annotationLayer: o,
      dragPoints: u,
      isEditable: l,
      selectionBoxDelta: -1,
      selectionBoxStroke: "transparent",
      selectionBoxThickness: 0,
      showLabel: !1,
      stroke: a,
      strokeDashArray: d,
      strokeThickness: 1,
      y1: s.value,
      yCoordinateMode: D.DataValue
    });
    if (l && f.dragDelta.subscribe(() => {
      s.onDrag?.(f.y1);
    }), e.annotations.add(f), s.label) {
      const h = Rr({
        value: s.value,
        visibleRange: e.yAxes.size() > 0 ? e.yAxes.get(0).visibleRange : void 0
      });
      e.annotations.add(new Ae({
        annotationLayer: o,
        horizontalAnchorPoint: we.Right,
        isEditable: !1,
        svgString: Ut({
          color: c,
          fontFamily: n,
          fontSize: r,
          text: s.label
        }),
        verticalAnchorPoint: h.verticalAnchorPoint,
        x1: 1,
        xCoordinateMode: D.Relative,
        xCoordShift: rr,
        y1: s.value,
        yCoordShift: h.yCoordShift,
        yCoordinateMode: D.DataValue
      }));
    }
  });
}
function hr({
  config: t,
  surface: e,
  wasmContext: i
}) {
  const n = new Set(t.visibleSeriesIds), r = new bn(i, {
    dataPointWidth: t.dataPointWidth,
    dataPointWidthMode: gn.Relative,
    spacing: 0
  });
  (t.stacked ? [...t.series].reverse() : t.series).forEach((o) => {
    const a = new le(i, {
      dataSeriesName: o.label
    }), c = [], d = [];
    o.data.forEach((u) => {
      c.push(M(u.x)), d.push(u.y ?? Number.NaN);
    }), a.appendRange(c, d);
    const l = new xn(i, {
      dataSeries: a,
      fill: I(wi(o.color, t.colorScheme)),
      stackedGroupId: t.stacked ? ir : o.id,
      strokeThickness: 0
    });
    l.isVisible = n.has(o.id), r.add(l);
  }), e.renderableSeries.add(r);
}
function mr({
  config: t,
  surface: e
}) {
  e.chartModifiers.add(new hi({
    showAxisLabels: !1,
    showTooltip: !0,
    showXLine: !1,
    showYLine: !1,
    tooltipSvgTemplate: Mi({
      colorScheme: t.colorScheme,
      markerTypeOverride: "square",
      series: t.series,
      tooltipRef: t.tooltipRef
    })
  }));
}
function pr(t) {
  return t.some((e) => e.data.some((i) => i.x instanceof Date));
}
const Gt = /* @__PURE__ */ new WeakMap();
function br({
  axis: t,
  hasDateAxis: e,
  xAxis: i
}) {
  const n = t.labelProvider, r = _i(n);
  n.formatLabel = (s) => {
    const o = i?.formatTick?.(e ? new Date(s * 1e3) : gt(s));
    return o || (e ? jn(new Date(s * 1e3), $i(t.visibleRange)) : ot(s, r));
  }, n.formatCursorLabel = (s) => e ? Ti(new Date(s * 1e3)) : ot(s, r);
}
function gr({
  axis: t,
  yAxis: e
}) {
  const i = t.labelProvider, n = _i(i);
  i.formatLabel = (r) => e?.formatTick?.(gt(r)) ?? ot(r, n);
}
function ot(t, e) {
  return e(gt(t));
}
function gt(t) {
  return Number(t.toPrecision(12));
}
function xr(t) {
  return Number.isFinite(t);
}
function _i(t) {
  const e = Gt.get(t);
  if (e)
    return e;
  const i = t.formatLabel?.bind(t) ?? ((n) => String(n));
  return Gt.set(t, i), i;
}
let yr = class extends mi {
  constructor() {
    super({
      useNativeText: !1
    }), this.textVariesForSameTick = !0, this.formatLabel = (e) => ki(new Date(e * 1e3), $i(this.parentAxis?.visibleRange));
  }
};
function vr(t, e) {
  if (e?.visibleRange)
    return new N(M(e.visibleRange.min), M(e.visibleRange.max));
  const i = t.flatMap((n) => n.data.map((r) => M(r.x)));
  return Ar(i);
}
function Sr(t) {
  if (t.yAxis?.visibleRange)
    return new N(Number(t.yAxis.visibleRange.min), Number(t.yAxis.visibleRange.max));
  if (t.yAxis?.baseline !== "zero")
    return;
  const e = new Set(t.visibleSeriesIds);
  if (!t.stacked) {
    const n = t.series.flatMap((r) => e.has(r.id) ? r.data.map((s) => s.y).filter(xr) : []);
    return jt([0, ...n]);
  }
  const i = /* @__PURE__ */ new Map();
  return t.series.forEach((n) => {
    e.has(n.id) && n.data.forEach((r) => {
      r.y !== null && i.set(M(r.x), (i.get(M(r.x)) ?? 0) + r.y);
    });
  }), jt([0, ...i.values()]);
}
function jt(t) {
  const e = t.filter(Number.isFinite);
  if (e.length === 0)
    return;
  const i = Math.min(...e), n = Math.max(...e);
  return i === n ? new N(i - 1, n + 1) : new N(i, n);
}
function Ar(t) {
  const e = [...new Set(t.filter(Number.isFinite))].sort((o, a) => o - a);
  if (e.length === 0)
    return;
  if (e.length === 1)
    return new N(e[0] - 1, e[0] + 1);
  const i = e[0], n = e[e.length - 1], r = e.slice(1).reduce((o, a, c) => {
    const d = e[c], l = a - d;
    return l > 0 ? Math.min(o, l) : o;
  }, Number.POSITIVE_INFINITY), s = Number.isFinite(r) ? r / 2 : 1;
  return new N(i - s, n + s);
}
function wr(t) {
  return t?.baseline === "zero" ? new N(0, 0.2) : new N(0.12, 0.2);
}
function Rr({
  value: t,
  visibleRange: e
}) {
  return e && Tr(t, e) ? {
    verticalAnchorPoint: te.Top,
    yCoordShift: Ht
  } : {
    verticalAnchorPoint: te.Bottom,
    yCoordShift: -Ht
  };
}
function Tr(t, e) {
  const i = e.max - e.min;
  return i <= 0 ? !1 : (t - e.min) / i >= sr;
}
function Ut({
  color: t,
  fontFamily: e,
  fontSize: i,
  rotation: n = 0,
  text: r
}) {
  const s = kr({
    fontSize: i,
    text: r
  });
  if (n === Li) {
    const d = Math.ceil(i * 1.3), l = d + 4, u = Math.ceil(s + 4);
    return `<svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="${l}" height="${u}" viewBox="0 0 ${l} ${u}">
    <text x="0" y="0" fill="${$e(t)}" font-size="${i}" font-family="${$e(e)}" font-weight="500" dominant-baseline="hanging" transform="translate(${2 + d} 2) rotate(${n})">${qt(r)}</text>
  </svg>`;
  }
  const o = Math.ceil(i * 1.4), a = Math.ceil(s);
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${a}" height="${o}" viewBox="0 0 ${a} ${o}">
    <text x="0" y="${i}" fill="${$e(t)}" font-size="${i}" font-family="${$e(e)}" font-weight="500">${qt(r)}</text>
  </svg>`;
}
function kr({
  fontSize: t,
  text: e
}) {
  return Math.max(t, e.length * t * 0.62);
}
function $e(t) {
  return t.replaceAll("&", "&amp;").replaceAll('"', "&quot;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
function qt(t) {
  return t.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
function Cr(t, e) {
  if (/^#[\da-f]{6}$/i.test(t)) {
    const i = Number.parseInt(t.slice(1, 3), 16), n = Number.parseInt(t.slice(3, 5), 16), r = Number.parseInt(t.slice(5, 7), 16);
    return `rgba(${i}, ${n}, ${r}, ${e})`;
  }
  if (/^#[\da-f]{3}$/i.test(t)) {
    const i = Number.parseInt(t[1] + t[1], 16), n = Number.parseInt(t[2] + t[2], 16), r = Number.parseInt(t[3] + t[3], 16);
    return `rgba(${i}, ${n}, ${r}, ${e})`;
  }
  return t.startsWith("hsl(") ? t.replace("hsl(", "hsla(").replace(")", ` / ${e})`) : t.startsWith("rgb(") ? t.replace("rgb(", "rgba(").replace(")", `, ${e})`) : t;
}
function $i(t) {
  return t ? Math.abs(t.max - t.min) : Number.POSITIVE_INFINITY;
}
function Wt(t) {
  const e = t === "bottom" ? new j(12, 0, 0, 0) : new j(0, 0, 12, 0);
  return {
    color: I("--text-text-default"),
    fontFamily: Ue("--font-family-label"),
    fontSize: qe("--font-size-label-large", 14),
    fontWeight: "600",
    padding: e,
    useNativeText: !1
  };
}
function Ir() {
  return {
    color: I("--text-text-subtle"),
    fontFamily: Ue("--font-family-body"),
    fontSize: qe("--font-size-label-nav", 10),
    fontWeight: "400",
    multilineAlignment: He.Center,
    padding: new j(8, 2, 2, 2)
  };
}
function Mr() {
  return {
    color: I("--text-text-subtle"),
    fontFamily: Ue("--font-family-body"),
    fontSize: qe("--font-size-body-small", 12),
    fontWeight: "400",
    multilineAlignment: He.Center,
    padding: new j(2, 4, 2, 4)
  };
}
function Kt(t) {
  return t ? I("--text-text-subtle") : "rgba(0, 0, 0, 0)";
}
function Ue(t) {
  return ie(t).replaceAll('"', "").trim() || "Inter";
}
function qe(t, e) {
  const i = Number.parseFloat(ie(t));
  return Number.isFinite(i) ? i : e;
}
function Xt(t) {
  return {
    color: t,
    strokeThickness: 1,
    tickSize: 8
  };
}
function Lr(t) {
  const e = _r(t), i = ve(t), [n, r] = Q(() => Nn(t));
  i.current = t, Se(() => {
    r((o) => {
      const a = i.current, c = new Set(a.map((l) => l.id)), d = o.filter((l) => c.has(l));
      for (const l of a)
        l.initiallyVisible !== !1 && !d.includes(l.id) && d.push(l.id);
      return d.length === 0 && a[0] && d.push(a[0].id), d.length === o.length && d.every((l, u) => l === o[u]) ? o : d;
    });
  }, [e]);
  function s(o) {
    r((a) => Dn(o, a));
  }
  return {
    visibleSeriesIds: n,
    setVisibleSeriesIds: r,
    toggleSeriesVisibility: s
  };
}
function _r(t) {
  return t.map((e) => [e.id, e.initiallyVisible === !1 ? "hidden" : "visible"].join(":")).join("|");
}
function xt(t) {
  const e = E.c(14), {
    series: i,
    visibleSeriesIds: n
  } = t, r = Lr(i), s = n ?? r.visibleSeriesIds;
  let o;
  e[0] !== i ? (o = Fn(i), e[0] = i, e[1] = o) : o = e[1];
  const a = o;
  let c;
  e[2] !== i ? (c = zn(i), e[2] = i, e[3] = c) : c = e[3];
  const d = c;
  let l, u;
  e[4] !== i || e[5] !== s ? (u = Vn(i, s), l = u.some($r), e[4] = i, e[5] = s, e[6] = l, e[7] = u) : (l = e[6], u = e[7]);
  const f = l;
  let h;
  return e[8] !== f || e[9] !== d || e[10] !== a || e[11] !== u || e[12] !== s ? (h = {
    hasData: f,
    resolvedSeries: d,
    validationErrors: a,
    visibleSeries: u,
    visibleSeriesIds: s
  }, e[8] = f, e[9] = d, e[10] = a, e[11] = u, e[12] = s, e[13] = h) : h = e[13], h;
}
function $r(t) {
  return t.data.some(Pr);
}
function Pr(t) {
  return t.y !== null;
}
const Nr = 320, Er = 4;
function fa(t) {
  const e = E.c(30), {
    colorScheme: i,
    dataPointWidth: n,
    series: r,
    stacked: s,
    stripLines: o,
    tooltip: a,
    xAxis: c,
    yAxis: d,
    visibleSeriesIds: l,
    height: u,
    emptyMessage: f,
    className: h
  } = t, b = i === void 0 ? "sequential" : i, p = s === void 0 ? !0 : s, m = u === void 0 ? Nr : u, g = f === void 0 ? "No data available" : f;
  let v;
  e[0] !== l || e[1] !== r ? (v = {
    series: r,
    visibleSeriesIds: l
  }, e[0] = l, e[1] = r, e[2] = v) : v = e[2];
  const {
    hasData: y,
    resolvedSeries: w,
    validationErrors: R,
    visibleSeriesIds: S
  } = xt(v);
  let L;
  if (e[3] !== b || e[4] !== r || e[5] !== p || e[6] !== R || e[7] !== S) {
    const C = p ? Vr(r, S) : [];
    L = [...R, ...Dr({
      colorScheme: b,
      visibleSeriesIds: S
    }), ...C], e[3] = b, e[4] = r, e[5] = p, e[6] = R, e[7] = S, e[8] = L;
  } else
    L = e[8];
  const k = L;
  let A;
  e[9] !== b || e[10] !== k.length || e[11] !== n || e[12] !== y || e[13] !== w || e[14] !== p || e[15] !== o || e[16] !== a || e[17] !== S || e[18] !== c || e[19] !== d ? (A = k.length === 0 && /* @__PURE__ */ x(dr, { dataPointWidth: n, colorScheme: b, series: w, stacked: p, stripLines: o, tooltip: a, visibleSeriesIds: S, showAxisLabels: !0, showAxisTickLabels: y, xAxis: c, yAxis: d }), e[9] = b, e[10] = k.length, e[11] = n, e[12] = y, e[13] = w, e[14] = p, e[15] = o, e[16] = a, e[17] = S, e[18] = c, e[19] = d, e[20] = A) : A = e[20];
  let _;
  e[21] !== k || e[22] !== g || e[23] !== y || e[24] !== m || e[25] !== A ? (_ = /* @__PURE__ */ x("div", { className: "flex flex-col gap-(--spacing-8)", children: /* @__PURE__ */ x(pt, { emptyMessage: g, hasData: y, height: m, validationErrors: k, children: A }) }), e[21] = k, e[22] = g, e[23] = y, e[24] = m, e[25] = A, e[26] = _) : _ = e[26];
  let $;
  return e[27] !== h || e[28] !== _ ? ($ = /* @__PURE__ */ x("div", { className: h, "data-chart-component": "bar-chart", "data-chart-renderer": "scichart", children: _ }), e[27] = h, e[28] = _, e[29] = $) : $ = e[29], $;
}
function Dr({
  colorScheme: t,
  visibleSeriesIds: e
}) {
  return t === "sequential" && e.length > Er ? ["Sequential bar charts support up to 4 visible series."] : [];
}
function Vr(t, e) {
  const i = t.filter((s) => e.includes(s.id)), n = i[0];
  if (!n)
    return [];
  const r = n.data.map((s) => M(s.x));
  return i.flatMap((s) => {
    const o = s.data.map((c) => M(c.x));
    return o.length === r.length && o.every((c, d) => c === r[d]) ? [] : ["Stacked bar chart series must use the same x values in the same order."];
  });
}
function Pi(t) {
  var e, i, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var r = t.length;
    for (e = 0; e < r; e++) t[e] && (i = Pi(t[e])) && (n && (n += " "), n += i);
  } else for (i in t) t[i] && (n && (n += " "), n += i);
  return n;
}
function zr() {
  for (var t, e, i = 0, n = "", r = arguments.length; i < r; i++) (t = arguments[i]) && (e = Pi(t)) && (n && (n += " "), n += e);
  return n;
}
const yt = "-", Fr = (t) => {
  const e = Br(t), {
    conflictingClassGroups: i,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (o) => {
      const a = o.split(yt);
      return a[0] === "" && a.length !== 1 && a.shift(), Ni(a, e) || Or(o);
    },
    getConflictingClassGroupIds: (o, a) => {
      const c = i[o] || [];
      return a && n[o] ? [...c, ...n[o]] : c;
    }
  };
}, Ni = (t, e) => {
  if (t.length === 0)
    return e.classGroupId;
  const i = t[0], n = e.nextPart.get(i), r = n ? Ni(t.slice(1), n) : void 0;
  if (r)
    return r;
  if (e.validators.length === 0)
    return;
  const s = t.join(yt);
  return e.validators.find(({
    validator: o
  }) => o(s))?.classGroupId;
}, Zt = /^\[(.+)\]$/, Or = (t) => {
  if (Zt.test(t)) {
    const e = Zt.exec(t)[1], i = e?.substring(0, e.indexOf(":"));
    if (i)
      return "arbitrary.." + i;
  }
}, Br = (t) => {
  const {
    theme: e,
    prefix: i
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Gr(Object.entries(t.classGroups), i).forEach(([s, o]) => {
    at(o, n, s, e);
  }), n;
}, at = (t, e, i, n) => {
  t.forEach((r) => {
    if (typeof r == "string") {
      const s = r === "" ? e : Yt(e, r);
      s.classGroupId = i;
      return;
    }
    if (typeof r == "function") {
      if (Hr(r)) {
        at(r(n), e, i, n);
        return;
      }
      e.validators.push({
        validator: r,
        classGroupId: i
      });
      return;
    }
    Object.entries(r).forEach(([s, o]) => {
      at(o, Yt(e, s), i, n);
    });
  });
}, Yt = (t, e) => {
  let i = t;
  return e.split(yt).forEach((n) => {
    i.nextPart.has(n) || i.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), i = i.nextPart.get(n);
  }), i;
}, Hr = (t) => t.isThemeGetter, Gr = (t, e) => e ? t.map(([i, n]) => {
  const r = n.map((s) => typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([o, a]) => [e + o, a])) : s);
  return [i, r];
}) : t, jr = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, i = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const r = (s, o) => {
    i.set(s, o), e++, e > t && (e = 0, n = i, i = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let o = i.get(s);
      if (o !== void 0)
        return o;
      if ((o = n.get(s)) !== void 0)
        return r(s, o), o;
    },
    set(s, o) {
      i.has(s) ? i.set(s, o) : r(s, o);
    }
  };
}, Ei = "!", Ur = (t) => {
  const {
    separator: e,
    experimentalParseClassName: i
  } = t, n = e.length === 1, r = e[0], s = e.length, o = (a) => {
    const c = [];
    let d = 0, l = 0, u;
    for (let m = 0; m < a.length; m++) {
      let g = a[m];
      if (d === 0) {
        if (g === r && (n || a.slice(m, m + s) === e)) {
          c.push(a.slice(l, m)), l = m + s;
          continue;
        }
        if (g === "/") {
          u = m;
          continue;
        }
      }
      g === "[" ? d++ : g === "]" && d--;
    }
    const f = c.length === 0 ? a : a.substring(l), h = f.startsWith(Ei), b = h ? f.substring(1) : f, p = u && u > l ? u - l : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: b,
      maybePostfixModifierPosition: p
    };
  };
  return i ? (a) => i({
    className: a,
    parseClassName: o
  }) : o;
}, qr = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let i = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...i.sort(), n), i = []) : i.push(n);
  }), e.push(...i.sort()), e;
}, Wr = (t) => ({
  cache: jr(t.cacheSize),
  parseClassName: Ur(t),
  ...Fr(t)
}), Kr = /\s+/, Xr = (t, e) => {
  const {
    parseClassName: i,
    getClassGroupId: n,
    getConflictingClassGroupIds: r
  } = e, s = [], o = t.trim().split(Kr);
  let a = "";
  for (let c = o.length - 1; c >= 0; c -= 1) {
    const d = o[c], {
      modifiers: l,
      hasImportantModifier: u,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = i(d);
    let b = !!h, p = n(b ? f.substring(0, h) : f);
    if (!p) {
      if (!b) {
        a = d + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (p = n(f), !p) {
        a = d + (a.length > 0 ? " " + a : a);
        continue;
      }
      b = !1;
    }
    const m = qr(l).join(":"), g = u ? m + Ei : m, v = g + p;
    if (s.includes(v))
      continue;
    s.push(v);
    const y = r(p, b);
    for (let w = 0; w < y.length; ++w) {
      const R = y[w];
      s.push(g + R);
    }
    a = d + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function Zr() {
  let t = 0, e, i, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (i = Di(e)) && (n && (n += " "), n += i);
  return n;
}
const Di = (t) => {
  if (typeof t == "string")
    return t;
  let e, i = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = Di(t[n])) && (i && (i += " "), i += e);
  return i;
};
function Yr(t, ...e) {
  let i, n, r, s = o;
  function o(c) {
    const d = e.reduce((l, u) => u(l), t());
    return i = Wr(d), n = i.cache.get, r = i.cache.set, s = a, a(c);
  }
  function a(c) {
    const d = n(c);
    if (d)
      return d;
    const l = Xr(c, i);
    return r(c, l), l;
  }
  return function() {
    return s(Zr.apply(null, arguments));
  };
}
const P = (t) => {
  const e = (i) => i[t] || [];
  return e.isThemeGetter = !0, e;
}, Vi = /^\[(?:([a-z-]+):)?(.+)\]$/i, Jr = /^\d+\/\d+$/, Qr = /* @__PURE__ */ new Set(["px", "full", "screen"]), es = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ts = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, is = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, ns = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, rs = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, X = (t) => ae(t) || Qr.has(t) || Jr.test(t), Z = (t) => de(t, "length", fs), ae = (t) => !!t && !Number.isNaN(Number(t)), Qe = (t) => de(t, "number", ae), pe = (t) => !!t && Number.isInteger(Number(t)), ss = (t) => t.endsWith("%") && ae(t.slice(0, -1)), T = (t) => Vi.test(t), Y = (t) => es.test(t), os = /* @__PURE__ */ new Set(["length", "size", "percentage"]), as = (t) => de(t, os, zi), ls = (t) => de(t, "position", zi), cs = /* @__PURE__ */ new Set(["image", "url"]), ds = (t) => de(t, cs, ms), us = (t) => de(t, "", hs), be = () => !0, de = (t, e, i) => {
  const n = Vi.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : i(n[2]) : !1;
}, fs = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  ts.test(t) && !is.test(t)
), zi = () => !1, hs = (t) => ns.test(t), ms = (t) => rs.test(t), ps = () => {
  const t = P("colors"), e = P("spacing"), i = P("blur"), n = P("brightness"), r = P("borderColor"), s = P("borderRadius"), o = P("borderSpacing"), a = P("borderWidth"), c = P("contrast"), d = P("grayscale"), l = P("hueRotate"), u = P("invert"), f = P("gap"), h = P("gradientColorStops"), b = P("gradientColorStopPositions"), p = P("inset"), m = P("margin"), g = P("opacity"), v = P("padding"), y = P("saturate"), w = P("scale"), R = P("sepia"), S = P("skew"), L = P("space"), k = P("translate"), A = () => ["auto", "contain", "none"], _ = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", T, e], C = () => [T, e], O = () => ["", X, Z], U = () => ["auto", ae, T], J = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Ie = () => ["solid", "dashed", "dotted", "double", "none"], Tt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Ke = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ue = () => ["", "0", T], kt = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], K = () => [ae, T];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [be],
      spacing: [X, Z],
      blur: ["none", "", Y, T],
      brightness: K(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Y, T],
      borderSpacing: C(),
      borderWidth: O(),
      contrast: K(),
      grayscale: ue(),
      hueRotate: K(),
      invert: ue(),
      gap: C(),
      gradientColorStops: [t],
      gradientColorStopPositions: [ss, Z],
      inset: $(),
      margin: $(),
      opacity: K(),
      padding: C(),
      saturate: K(),
      scale: K(),
      sepia: ue(),
      skew: K(),
      space: C(),
      translate: C()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", T]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Y]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": kt()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": kt()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...J(), T]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: _()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": _()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": _()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [p]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [p]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [p]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [p]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [p]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [p]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [p]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [p]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [p]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", pe, T]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", T]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ue()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ue()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", pe, T]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [be]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", pe, T]
        }, T]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [be]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [pe, T]
        }, T]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", T]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", T]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...Ke()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Ke(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...Ke(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [L]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [L]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", T, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [T, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [T, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Y]
        }, Y]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [T, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [T, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [T, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [T, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Y, Z]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Qe]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [be]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", T]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ae, Qe]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", X, T]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", T]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", T]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ie(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", X, Z]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", X, T]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: C()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", T]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", T]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...J(), ls]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", as]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ds]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ie(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Ie()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [r]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Ie()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [X, T]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [X, Z]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [X, Z]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Y, us]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [be]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Tt(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Tt()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [i]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Y, T]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [l]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [i]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [l]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", T]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", T]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", T]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [pe, T]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [k]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [k]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", T]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", T]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": C()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": C()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": C()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": C()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": C()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": C()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": C()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": C()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": C()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": C()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": C()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": C()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": C()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": C()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": C()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": C()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": C()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": C()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", T]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [X, Z, Qe]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, bs = /* @__PURE__ */ Yr(ps);
function q(...t) {
  return bs(zr(t));
}
function Fi(t) {
  const e = E.c(10);
  let i, n, r;
  e[0] !== t ? ({
    children: i,
    className: n,
    ...r
  } = t, e[0] = t, e[1] = i, e[2] = n, e[3] = r) : (i = e[1], n = e[2], r = e[3]);
  let s;
  e[4] !== n ? (s = q("w-full rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-16) pt-(--spacing-8) pb-(--spacing-16)", n), e[4] = n, e[5] = s) : s = e[5];
  let o;
  return e[6] !== i || e[7] !== r || e[8] !== s ? (o = /* @__PURE__ */ x("section", { className: s, ...r, children: i }), e[6] = i, e[7] = r, e[8] = s, e[9] = o) : o = e[9], o;
}
function gs(t) {
  const e = E.c(13), {
    title: i,
    subtitle: n,
    leadingControls: r,
    trailingControls: s
  } = t;
  let o;
  e[0] !== r || e[1] !== s ? (o = (r || s) && /* @__PURE__ */ V("div", { className: "flex min-w-0 flex-wrap items-start justify-between gap-(--spacing-24)", children: [
    r && /* @__PURE__ */ x("div", { className: "min-w-0 flex-1 overflow-hidden", children: r }),
    s && /* @__PURE__ */ x("div", { className: "ml-auto flex shrink-0 items-center gap-[2px]", children: s })
  ] }), e[0] = r, e[1] = s, e[2] = o) : o = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ x("h3", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) leading-(--font-line-height-28) font-(--font-weight-semibold) tracking-normal text-text-default", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let c;
  e[5] !== n ? (c = n && /* @__PURE__ */ x("p", { className: "mt-(--spacing-4) font-(family-name:--font-family-body) text-(length:--font-size-body-md) leading-(--line-height-20) font-normal tracking-normal text-text-subtle", children: n }), e[5] = n, e[6] = c) : c = e[6];
  let d;
  e[7] !== a || e[8] !== c ? (d = /* @__PURE__ */ V("div", { className: "min-w-0 text-center", children: [
    a,
    c
  ] }), e[7] = a, e[8] = c, e[9] = d) : d = e[9];
  let l;
  return e[10] !== o || e[11] !== d ? (l = /* @__PURE__ */ V("div", { className: "flex min-w-0 flex-col gap-(--spacing-8)", children: [
    o,
    d
  ] }), e[10] = o, e[11] = d, e[12] = l) : l = e[12], l;
}
function ha(t) {
  const e = E.c(13), {
    title: i,
    subtitle: n,
    leadingControls: r,
    trailingControls: s,
    children: o,
    className: a
  } = t;
  let c;
  e[0] !== r || e[1] !== n || e[2] !== i || e[3] !== s ? (c = /* @__PURE__ */ x(gs, { title: i, subtitle: n, leadingControls: r, trailingControls: s }), e[0] = r, e[1] = n, e[2] = i, e[3] = s, e[4] = c) : c = e[4];
  let d;
  e[5] !== o ? (d = /* @__PURE__ */ x("div", { className: "min-w-0", children: o }), e[5] = o, e[6] = d) : d = e[6];
  let l;
  e[7] !== c || e[8] !== d ? (l = /* @__PURE__ */ V("div", { className: "flex min-w-0 flex-col gap-(--spacing-8)", children: [
    c,
    d
  ] }), e[7] = c, e[8] = d, e[9] = l) : l = e[9];
  let u;
  return e[10] !== a || e[11] !== l ? (u = /* @__PURE__ */ x(Fi, { className: a, "data-chart-component": "chart-frame", children: l }), e[10] = a, e[11] = l, e[12] = u) : u = e[12], u;
}
const xs = {
  triangle: "polygon(50% 0%, 0% 100%, 100% 100%)",
  cross: "polygon(35% 0%,65% 0%,65% 35%,100% 35%,100% 65%,65% 65%,65% 100%,35% 100%,35% 65%,0% 65%,0% 35%,35% 35%)",
  x: "polygon(20% 0%,50% 30%,80% 0%,100% 20%,70% 50%,100% 80%,80% 100%,50% 70%,20% 100%,0% 80%,30% 50%,0% 20%)"
};
function ys(t) {
  const e = E.c(9), {
    type: i,
    color: n,
    colorScheme: r
  } = t, s = xs[i], o = i === "circle" && "rounded-full";
  let a;
  e[0] !== n || e[1] !== r || e[2] !== o ? (a = q("size-(--spacing-8) shrink-0", o, In(n, r)), e[0] = n, e[1] = r, e[2] = o, e[3] = a) : a = e[3];
  let c;
  e[4] !== s ? (c = s ? {
    clipPath: s
  } : void 0, e[4] = s, e[5] = c) : c = e[5];
  let d;
  return e[6] !== a || e[7] !== c ? (d = /* @__PURE__ */ x("span", { "aria-hidden": "true", className: a, style: c }), e[6] = a, e[7] = c, e[8] = d) : d = e[8], d;
}
function ma(t) {
  const e = E.c(20), {
    series: i,
    visibleSeriesIds: n,
    onToggleSeries: r,
    colorScheme: s,
    pointMarkers: o,
    markerType: a,
    showCheckboxes: c,
    className: d
  } = t, l = s === void 0 ? "qualitative" : s, f = (c === void 0 ? !0 : c) && r !== void 0;
  if (i.length <= 1)
    return null;
  let h;
  e[0] !== d ? (h = q("flex flex-wrap items-center justify-center gap-x-(--spacing-16) gap-y-(--spacing-4)", d), e[0] = d, e[1] = h) : h = e[1];
  let b;
  if (e[2] !== f || e[3] !== l || e[4] !== a || e[5] !== r || e[6] !== o || e[7] !== i || e[8] !== n) {
    let m;
    e[10] !== f || e[11] !== l || e[12] !== a || e[13] !== r || e[14] !== o || e[15] !== n ? (m = (g, v) => {
      const y = n.includes(g.id), w = En(g.id, n), R = je(g, v), S = a ?? Ri(g, o), L = /* @__PURE__ */ V(mn, { children: [
        /* @__PURE__ */ x(ys, { type: S, color: R, colorScheme: l }),
        /* @__PURE__ */ x("span", { className: q("min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-sm) leading-(--line-height-16) font-normal tracking-normal", "text-text-default"), children: g.label })
      ] });
      return /* @__PURE__ */ V("div", { className: q("group inline-flex h-(--spacing-24) max-w-full items-center gap-(--spacing-6)", f && !w && "cursor-not-allowed"), children: [
        f && /* @__PURE__ */ x(An, { size: "sm", checked: y, disabled: !w, "aria-label": `Toggle ${g.label}`, onCheckedChange: () => r(g.id) }),
        f ? /* @__PURE__ */ x("button", { type: "button", disabled: !w, onClick: () => r(g.id), className: q("inline-flex min-w-0 items-center gap-(--spacing-8) border-0 bg-transparent p-0 text-left", w ? "cursor-pointer" : "cursor-not-allowed", !y && "opacity-40"), children: L }) : /* @__PURE__ */ x("span", { className: q("inline-flex min-w-0 items-center gap-(--spacing-8)", !y && "opacity-40"), children: L })
      ] }, g.id);
    }, e[10] = f, e[11] = l, e[12] = a, e[13] = r, e[14] = o, e[15] = n, e[16] = m) : m = e[16], b = i.map(m), e[2] = f, e[3] = l, e[4] = a, e[5] = r, e[6] = o, e[7] = i, e[8] = n, e[9] = b;
  } else
    b = e[9];
  let p;
  return e[17] !== h || e[18] !== b ? (p = /* @__PURE__ */ x("div", { className: h, children: b }), e[17] = h, e[18] = b, e[19] = p) : p = e[19], p;
}
const vs = 4, Oi = 8, Bi = 6;
function pa(t) {
  const e = E.c(21), {
    height: i,
    legendItems: n,
    xTickCount: r,
    yTickCount: s,
    showHeader: o,
    showLegend: a,
    className: c
  } = t, d = i === void 0 ? 420 : i, l = n === void 0 ? vs : n, u = r === void 0 ? Oi : r, f = s === void 0 ? Bi : s, h = o === void 0 ? !0 : o, b = a === void 0 ? !0 : a;
  let p;
  e[0] !== c ? (p = q("bg-surface-container-lowest", c), e[0] = c, e[1] = p) : p = e[1];
  let m;
  e[2] !== d ? (m = {
    minHeight: d
  }, e[2] = d, e[3] = m) : m = e[3];
  let g;
  e[4] !== h ? (g = h && /* @__PURE__ */ x(Rs, {}), e[4] = h, e[5] = g) : g = e[5];
  let v;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ x(G, { width: 200, height: 18, className: "mx-auto" }), e[6] = v) : v = e[6];
  let y;
  e[7] !== l || e[8] !== b ? (y = b && /* @__PURE__ */ x(Ts, { itemCount: l }), e[7] = l, e[8] = b, e[9] = y) : y = e[9];
  let w;
  e[10] !== u || e[11] !== f ? (w = /* @__PURE__ */ x(Ss, { xTickCount: u, yTickCount: f, className: "flex-1" }), e[10] = u, e[11] = f, e[12] = w) : w = e[12];
  let R;
  e[13] !== y || e[14] !== w || e[15] !== m || e[16] !== g ? (R = /* @__PURE__ */ V("div", { className: "flex min-w-0 flex-col gap-(--spacing-16)", style: m, children: [
    g,
    v,
    y,
    w
  ] }), e[13] = y, e[14] = w, e[15] = m, e[16] = g, e[17] = R) : R = e[17];
  let S;
  return e[18] !== R || e[19] !== p ? (S = /* @__PURE__ */ x(Fi, { className: p, "data-chart-component": "chart-skeleton", "aria-label": "Loading chart", "aria-busy": "true", children: R }), e[18] = R, e[19] = p, e[20] = S) : S = e[20], S;
}
function Ss(t) {
  const e = E.c(20), {
    showXAxisTitle: i,
    xTickCount: n,
    yTickCount: r,
    className: s
  } = t, o = i === void 0 ? !0 : i, a = n === void 0 ? Oi : n, c = r === void 0 ? Bi : r;
  let d;
  e[0] !== s ? (d = q("grid min-h-[280px] min-w-0 grid-rows-[1fr_auto_auto] gap-y-(--spacing-16)", s), e[0] = s, e[1] = d) : d = e[1];
  let l;
  e[2] !== c ? (l = lt(c).map(ws), e[2] = c, e[3] = l) : l = e[3];
  let u;
  e[4] !== l ? (u = /* @__PURE__ */ x("div", { className: "grid min-h-0 content-between gap-y-(--spacing-24)", children: l }), e[4] = l, e[5] = u) : u = e[5];
  const f = `repeat(${Math.max(1, a)}, minmax(0, 1fr))`;
  let h;
  e[6] !== f ? (h = {
    gridTemplateColumns: f
  }, e[6] = f, e[7] = h) : h = e[7];
  let b;
  e[8] !== a ? (b = lt(a).map(As), e[8] = a, e[9] = b) : b = e[9];
  let p;
  e[10] !== h || e[11] !== b ? (p = /* @__PURE__ */ x("div", { className: "grid px-[18px]", style: h, children: b }), e[10] = h, e[11] = b, e[12] = p) : p = e[12];
  let m;
  e[13] !== o ? (m = o && /* @__PURE__ */ x(G, { width: 60, height: 12, className: "mx-auto" }), e[13] = o, e[14] = m) : m = e[14];
  let g;
  return e[15] !== p || e[16] !== m || e[17] !== d || e[18] !== u ? (g = /* @__PURE__ */ V("div", { className: d, "data-chart-component": "chart-skeleton-plot", "aria-hidden": "true", children: [
    u,
    p,
    m
  ] }), e[15] = p, e[16] = m, e[17] = d, e[18] = u, e[19] = g) : g = e[19], g;
}
function As(t) {
  return /* @__PURE__ */ x(G, { width: 34, height: 22, className: "mx-auto" }, t);
}
function ws(t) {
  return /* @__PURE__ */ V("div", { className: "grid grid-cols-[44px_minmax(0,1fr)] items-center gap-(--spacing-8)", children: [
    /* @__PURE__ */ x(G, { width: 28, height: 11, className: "justify-self-start" }),
    /* @__PURE__ */ x(G, { height: 1, className: "flex-1", radius: "none" })
  ] }, t);
}
function Rs() {
  const t = E.c(2);
  let e;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ V("div", { className: "flex min-w-0 gap-(--spacing-12)", children: [
    /* @__PURE__ */ x(G, { width: 90, height: 22 }),
    /* @__PURE__ */ x(G, { width: 80, height: 22 })
  ] }), t[0] = e) : e = t[0];
  let i;
  return t[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ V("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    e,
    /* @__PURE__ */ V("div", { className: "flex shrink-0 gap-(--spacing-8)", children: [
      /* @__PURE__ */ x(G, { width: 22, height: 22 }),
      /* @__PURE__ */ x(G, { width: 22, height: 22 }),
      /* @__PURE__ */ x(G, { width: 22, height: 22 })
    ] })
  ] }), t[1] = i) : i = t[1], i;
}
function Ts(t) {
  const e = E.c(4), {
    itemCount: i
  } = t;
  let n;
  e[0] !== i ? (n = lt(i).map(ks), e[0] = i, e[1] = n) : n = e[1];
  let r;
  return e[2] !== n ? (r = /* @__PURE__ */ x("div", { className: "flex flex-wrap items-center justify-center gap-x-(--spacing-16) gap-y-(--spacing-4)", children: n }), e[2] = n, e[3] = r) : r = e[3], r;
}
function ks(t) {
  return /* @__PURE__ */ V("div", { className: "flex items-center gap-(--spacing-8)", children: [
    /* @__PURE__ */ x(G, { width: 16, height: 16 }),
    /* @__PURE__ */ x(G, { width: 52, height: 12 })
  ] }, t);
}
function lt(t) {
  return Array.from({
    length: Math.max(0, t)
  }, (e, i) => String(i));
}
function ba(t) {
  const e = E.c(4), {
    items: i
  } = t;
  if (i.length === 0)
    return null;
  let n;
  e[0] !== i ? (n = i.map(Cs), e[0] = i, e[1] = n) : n = e[1];
  let r;
  return e[2] !== n ? (r = /* @__PURE__ */ x("div", { className: "max-w-[240px] rounded-(--radius-sm) border border-outline-subtle bg-chart-tooltip-background p-(--spacing-12) shadow-elevation-2", children: /* @__PURE__ */ x("div", { className: "flex flex-col gap-(--spacing-8)", children: n }) }), e[2] = n, e[3] = r) : r = e[3], r;
}
function Cs(t) {
  return /* @__PURE__ */ V("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    /* @__PURE__ */ x("span", { "aria-hidden": "true", className: q("size-(--spacing-10) shrink-0 rounded-full", Ai[t.color]) }),
    /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-sm) leading-(--line-height-16) font-normal tracking-normal text-text-subtle", children: t.label }),
    /* @__PURE__ */ x("span", { className: "shrink-0 font-(family-name:--font-family-label) text-(length:--font-size-label-md) leading-(--line-height-16) font-(--font-weight-semibold) tracking-normal text-text-default", children: t.value })
  ] }, t.id);
}
const ct = /* @__PURE__ */ new Map();
function Is({
  axis: t,
  syncGroup: e
}) {
  const i = Ms(e);
  i.visibleRange ? t.visibleRange = ze(i.visibleRange) : i.visibleRange = ze(t.visibleRange);
  const n = (r) => {
    !r?.visibleRange || i.isApplyingRange || Ls({
      axisSyncGroup: i,
      sourceAxis: t,
      visibleRange: r.visibleRange
    });
  };
  return t.visibleRangeChanged.subscribe(n), i.axes.push({
    axis: t,
    handleVisibleRangeChanged: n
  }), () => {
    t.visibleRangeChanged.unsubscribe(n), i.axes = i.axes.filter((r) => r.axis !== t), i.axes.length === 0 && ct.delete(e);
  };
}
function Ms(t) {
  const e = ct.get(t);
  if (e)
    return e;
  const i = {
    axes: [],
    isApplyingRange: !1
  };
  return ct.set(t, i), i;
}
function Ls({
  axisSyncGroup: t,
  sourceAxis: e,
  visibleRange: i
}) {
  t.visibleRange = ze(i), t.isApplyingRange = !0;
  try {
    for (const n of t.axes)
      n.axis !== e && (n.axis.visibleRange = ze(i));
  } finally {
    t.isApplyingRange = !1;
  }
}
function ze(t) {
  return new N(t.min, t.max);
}
const W = "left", F = "right", _s = {
  negative: "--datavis-datavis-bg-critical-red",
  neutral: "--surface-surface-container-low",
  positive: "--datavis-datavis-bg-critical-green",
  warning: "--datavis-datavis-bg-critical-yellow"
}, $s = {
  medium: 0.5,
  strong: 1,
  subtle: 0.35
}, Ps = 0.8, Ns = -8, Jt = 4, Es = 0.9, Hi = "__assetwatch-horizontal-strip-line__", vt = "__assetwatch-horizontal-strip-line-label__", Ds = "__assetwatch-vertical-strip-line__", Vs = "__assetwatch-vertical-strip-line-label__", Gi = 90, zs = 0, Fs = 4, Os = 0, Bs = [], ji = {
  dashDot: [10, 5, 2, 5],
  dotted: [2, 4],
  longDash: [12, 6],
  shortDash: [6, 4],
  solid: []
};
function Ui({
  series: t,
  visibleSeriesIds: e,
  xAxis: i,
  yAxis: n,
  yAxisSecondary: r,
  shadingRegions: s = [],
  stripLines: o = Bs,
  tooltip: a,
  zoom: c,
  pointMarkers: d = !1,
  onDataPointClick: l,
  pointAnnotations: u = [],
  getPointKey: f,
  seriesType: h = "line",
  showAxisLabels: b = !0,
  showAxisTickLabels: p = !0
}) {
  const m = ai().replaceAll(":", ""), g = ve(void 0), [v, y] = Q(null), w = Hs(), R = zo(c), S = {
    getPointKey: f,
    onDataPointClick: l,
    pointAnnotations: u,
    pointMarkers: d,
    seriesType: h,
    series: t,
    shadingRegions: s,
    stripLines: o,
    showAxisLabels: b,
    showAxisTickLabels: p,
    tooltip: a,
    visibleSeriesIds: e,
    xAxis: i,
    yAxis: n,
    yAxisSecondary: r,
    zoomCallbacks: js(c),
    zoomConfig: R
  }, L = ve(S), k = Bo(S), A = De(S);
  return L.current = S, Se(() => {
    let _ = !1, $;
    async function C() {
      try {
        const O = await St.create({
          chartId: m,
          config: L.current
        });
        if (_) {
          O.dispose();
          return;
        }
        $ = O, g.current = $, $.update(L.current, De(L.current)), y(null);
      } catch (O) {
        _ || y(O instanceof Error ? O.message : "Unable to render chart");
      }
    }
    return C(), () => {
      _ = !0, g.current = void 0, $?.dispose();
    };
  }, [m, k.axes, k.pointMarkers, k.shadingRegions, k.series, k.seriesType, k.stripLines, w, k.tooltip, k.zoom]), Se(() => {
    A.axisFormatters.x, A.axisFormatters.y, A.axisFormatters.ySecondary, A.axisVisibleRanges, A.getPointKey, A.pointAnnotations, A.seriesData, A.showAxisLabels, A.showAxisTickLabels, A.stripLines, A.visibleSeries, A.zoomInteractionMode, g.current?.update(L.current, De(L.current));
  }, [f, l, A.axisFormatters.x, A.axisFormatters.y, A.axisFormatters.ySecondary, A.axisVisibleRanges, A.getPointKey, A.pointAnnotations, A.seriesData, A.showAxisLabels, A.showAxisTickLabels, o, A.stripLines, A.visibleSeries, A.zoomInteractionMode, c]), /* @__PURE__ */ V("div", { className: "relative h-full w-full", children: [
    /* @__PURE__ */ x("div", { id: m, className: "h-full w-full" }),
    v && /* @__PURE__ */ x("div", { className: "absolute inset-0 flex items-center justify-center bg-surface", children: /* @__PURE__ */ x("p", { className: "max-w-[320px] text-center font-(family-name:--font-family-body) text-(length:--font-size-body-sm) leading-(--line-height-16) font-normal tracking-normal text-text-subtle", children: v }) })
  ] });
}
const Qt = /* @__PURE__ */ new WeakMap();
class St {
  constructor(e, i, n) {
    this.surface = e, this.wasmContext = i, this.getPointKeyRef = {
      current: n.getPointKey
    }, this.onDataPointClickRef = {
      current: n.onDataPointClick
    }, this.pointMarkersRef = {
      current: n.pointMarkers
    }, this.seriesRef = {
      current: n.series
    }, this.stripLinesRef = {
      current: n.stripLines
    }, this.tooltipRef = {
      current: n.tooltip
    }, this.visibleSeriesIdsRef = {
      current: n.visibleSeriesIds
    }, this.xAxisRef = {
      current: n.xAxis
    }, this.yAxisRef = {
      current: n.yAxis
    }, this.yAxisSecondaryRef = {
      current: n.yAxisSecondary
    }, this.zoomCallbacksRef = {
      current: n.zoomCallbacks
    }, this.previousUpdateKeys = De(n);
  }
  surface;
  wasmContext;
  previousUpdateKeys;
  unregisterResetZoom;
  unregisterSyncedXAxis;
  unsubscribeAdaptivePointMarkers;
  unsubscribeXAxisRangeYAxisAutoFit;
  unsubscribeZoomState;
  getPointKeyRef;
  onDataPointClickRef;
  pointMarkersRef;
  seriesRef;
  tooltipRef;
  stripLinesRef;
  visibleSeriesIdsRef;
  xAxisRef;
  yAxisRef;
  yAxisSecondaryRef;
  zoomCallbacksRef;
  static async create({
    chartId: e,
    config: i
  }) {
    const n = await ge.create(e, {
      freezeWhenOutOfView: !0,
      padding: new j(0, 4, 0, 4),
      theme: {
        ...new li(),
        sciChartBackground: "Transparent",
        loadingAnimationBackground: "Transparent",
        loadingAnimationForeground: I("--primary-primary")
      }
    }), r = new St(n.sciChartSurface, n.wasmContext, i);
    return r.initialize(i), r;
  }
  update(e, i) {
    this.syncRefs(e), this.previousUpdateKeys.visibleSeries !== i.visibleSeries && (Po({
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds
    }), Ee({
      getPointKeyRef: this.getPointKeyRef,
      pointAnnotations: e.pointAnnotations,
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds,
      wasmContext: this.wasmContext
    }), ye({
      applyXRange: !1,
      pointMarkersRef: this.pointMarkersRef,
      seriesType: e.seriesType,
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds,
      wasmContext: this.wasmContext,
      xAxis: e.xAxis,
      yAxis: e.yAxis,
      yAxisSecondary: e.yAxisSecondary
    })), this.previousUpdateKeys.seriesData !== i.seriesData ? _o({
      getPointKeyRef: this.getPointKeyRef,
      pointAnnotations: e.pointAnnotations,
      pointMarkersRef: this.pointMarkersRef,
      seriesType: e.seriesType,
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds,
      wasmContext: this.wasmContext
    }) : (this.previousUpdateKeys.pointAnnotations !== i.pointAnnotations || this.previousUpdateKeys.getPointKey !== i.getPointKey) && Ee({
      getPointKeyRef: this.getPointKeyRef,
      pointAnnotations: e.pointAnnotations,
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds,
      wasmContext: this.wasmContext
    }), (this.previousUpdateKeys.seriesData !== i.seriesData || this.previousUpdateKeys.axisVisibleRanges !== i.axisVisibleRanges) && ye({
      onControlledRangeApplied: () => {
        this.zoomCallbacksRef.current.onZoomStateChange?.(!1);
      },
      pointMarkersRef: this.pointMarkersRef,
      seriesType: e.seriesType,
      series: e.series,
      surface: this.surface,
      visibleSeriesIds: e.visibleSeriesIds,
      wasmContext: this.wasmContext,
      xAxis: e.xAxis,
      yAxis: e.yAxis,
      yAxisSecondary: e.yAxisSecondary
    }), (this.previousUpdateKeys.showAxisLabels !== i.showAxisLabels || this.previousUpdateKeys.showAxisTickLabels !== i.showAxisTickLabels) && Qs({
      showAxisLabels: e.showAxisLabels,
      showAxisTickLabels: e.showAxisTickLabels,
      surface: this.surface,
      xAxis: e.xAxis,
      yAxis: e.yAxis,
      yAxisSecondary: e.yAxisSecondary
    }), this.previousUpdateKeys.stripLines !== i.stripLines && oo({
      stripLines: e.stripLines,
      surface: this.surface
    }), Ho(this.previousUpdateKeys.axisFormatters, i.axisFormatters) && Js({
      hasDateAxis: qi(e.series),
      surface: this.surface,
      xAxisRef: this.xAxisRef,
      yAxisRef: this.yAxisRef,
      yAxisSecondaryRef: this.yAxisSecondaryRef
    }), this.previousUpdateKeys.zoomInteractionMode !== i.zoomInteractionMode && Vo({
      surface: this.surface,
      zoomConfig: e.zoomConfig
    }), this.previousUpdateKeys = i;
  }
  dispose() {
    this.unregisterSyncedXAxis?.(), this.unregisterResetZoom?.(), this.unsubscribeXAxisRangeYAxisAutoFit?.(), this.unsubscribeZoomState?.(), this.unsubscribeAdaptivePointMarkers?.(), this.surface.delete();
  }
  initialize(e) {
    this.surface.background = "transparent", this.surface.suspendUpdates();
    try {
      Ys({
        surface: this.surface,
        wasmContext: this.wasmContext,
        series: e.series,
        visibleSeriesIds: e.visibleSeriesIds,
        showAxisLabels: e.showAxisLabels,
        showAxisTickLabels: e.showAxisTickLabels,
        xAxis: e.xAxis,
        xAxisRef: this.xAxisRef,
        yAxis: e.yAxis,
        yAxisRef: this.yAxisRef,
        yAxisSecondary: e.yAxisSecondary,
        yAxisSecondaryRef: this.yAxisSecondaryRef
      }), no({
        shadingRegions: e.shadingRegions,
        surface: this.surface
      }), ro({
        stripLinesRef: this.stripLinesRef,
        stripLines: e.stripLines,
        surface: this.surface
      }), ho({
        surface: this.surface,
        wasmContext: this.wasmContext,
        series: e.series,
        seriesType: e.seriesType,
        visibleSeriesIds: e.visibleSeriesIds,
        pointMarkers: e.pointMarkers
      }), ye({
        pointMarkersRef: this.pointMarkersRef,
        seriesType: e.seriesType,
        series: e.series,
        surface: this.surface,
        visibleSeriesIds: e.visibleSeriesIds,
        wasmContext: this.wasmContext,
        xAxis: e.xAxis,
        yAxis: e.yAxis,
        yAxisSecondary: e.yAxisSecondary
      }), Ee({
        getPointKeyRef: this.getPointKeyRef,
        pointAnnotations: e.pointAnnotations,
        series: e.series,
        surface: this.surface,
        visibleSeriesIds: e.visibleSeriesIds,
        wasmContext: this.wasmContext
      }), this.unsubscribeAdaptivePointMarkers = go({
        pointMarkersRef: this.pointMarkersRef,
        seriesType: e.seriesType,
        seriesRef: this.seriesRef,
        surface: this.surface,
        wasmContext: this.wasmContext
      }), xo({
        onDataPointClickRef: this.onDataPointClickRef,
        seriesRef: this.seriesRef,
        surface: this.surface
      }), yo({
        surface: this.surface,
        wasmContext: this.wasmContext
      }), Do({
        onZoomExtents: (i) => this.xAxisRef.current?.visibleRange || this.yAxisRef.current?.visibleRange || this.yAxisSecondaryRef.current?.visibleRange || this.yAxisRef.current?.baseline === "zero" || this.yAxisSecondaryRef.current?.baseline === "zero" ? (ri({
          series: this.seriesRef.current,
          surface: i,
          visibleSeriesIds: this.visibleSeriesIdsRef.current,
          xAxis: this.xAxisRef.current,
          yAxis: this.yAxisRef.current,
          yAxisSecondary: this.yAxisSecondaryRef.current,
          zoomCallbacksRef: this.zoomCallbacksRef
        }), !1) : !0,
        surface: this.surface,
        zoomConfig: e.zoomConfig
      }), Eo({
        surface: this.surface,
        series: e.series,
        pointMarkers: e.pointMarkers,
        tooltipRef: this.tooltipRef
      }), this.unsubscribeZoomState = Us({
        callbacksRef: this.zoomCallbacksRef,
        fullRange: Ws(this.surface),
        surface: this.surface
      }), this.unsubscribeXAxisRangeYAxisAutoFit = qs({
        seriesRef: this.seriesRef,
        surface: this.surface,
        visibleSeriesIdsRef: this.visibleSeriesIdsRef,
        xAxisRef: this.xAxisRef,
        yAxisRef: this.yAxisRef,
        yAxisSecondaryRef: this.yAxisSecondaryRef
      }), e.zoomConfig.syncGroup && this.surface.xAxes.size() > 0 && (this.unregisterSyncedXAxis = Is({
        axis: this.surface.xAxes.get(0),
        syncGroup: e.zoomConfig.syncGroup
      }));
    } finally {
      this.surface.resumeUpdates({
        invalidateOnResume: !0
      });
    }
    this.unregisterResetZoom = this.zoomCallbacksRef.current.onResetZoomReady?.(() => {
      if (this.xAxisRef.current?.visibleRange || this.yAxisRef.current?.visibleRange || this.yAxisSecondaryRef.current?.visibleRange || this.yAxisRef.current?.baseline === "zero" || this.yAxisSecondaryRef.current?.baseline === "zero") {
        ri({
          series: this.seriesRef.current,
          surface: this.surface,
          visibleSeriesIds: this.visibleSeriesIdsRef.current,
          xAxis: this.xAxisRef.current,
          yAxis: this.yAxisRef.current,
          yAxisSecondary: this.yAxisSecondaryRef.current,
          zoomCallbacksRef: this.zoomCallbacksRef
        });
        return;
      }
      this.surface.zoomExtents();
    });
  }
  syncRefs(e) {
    this.getPointKeyRef.current = e.getPointKey, this.onDataPointClickRef.current = e.onDataPointClick, this.pointMarkersRef.current = e.pointMarkers, this.seriesRef.current = e.series, this.stripLinesRef.current = e.stripLines, this.tooltipRef.current = e.tooltip, this.visibleSeriesIdsRef.current = e.visibleSeriesIds, this.xAxisRef.current = e.xAxis, this.yAxisRef.current = e.yAxis, this.yAxisSecondaryRef.current = e.yAxisSecondary, this.zoomCallbacksRef.current = e.zoomCallbacks;
  }
}
function Hs() {
  const t = E.c(2), [e, i] = Q(0);
  let n, r;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = () => {
    const s = new MutationObserver(() => {
      i(Gs);
    });
    return s.observe(document.documentElement, {
      attributeFilter: ["class"],
      attributes: !0
    }), () => {
      s.disconnect();
    };
  }, r = [], t[0] = n, t[1] = r) : (n = t[0], r = t[1]), Se(n, r), e;
}
function Gs(t) {
  return t + 1;
}
function js(t) {
  return !t || t === !0 ? {} : {
    onResetZoomReady: t.onResetZoomReady,
    onZoomStateChange: t.onZoomStateChange
  };
}
function Us({
  callbacksRef: t,
  fullRange: e,
  surface: i
}) {
  if (i.xAxes.size() === 0 || !e)
    return;
  const n = i.xAxes.get(0);
  let r = !1;
  const s = (o) => {
    const a = o?.visibleRange;
    if (!a)
      return;
    const c = {
      max: a.max,
      min: a.min
    }, d = Ks(e), l = Zs({
      currentRange: c,
      fullRange: e,
      threshold: d
    });
    l !== r && (r = l, t.current.onZoomStateChange?.(l));
  };
  return n.visibleRangeChanged.subscribe(s), () => {
    n.visibleRangeChanged.unsubscribe(s);
  };
}
function qs({
  seriesRef: t,
  surface: e,
  visibleSeriesIdsRef: i,
  xAxisRef: n,
  yAxisRef: r,
  yAxisSecondaryRef: s
}) {
  if (e.xAxes.size() === 0)
    return;
  const o = e.xAxes.get(0);
  let a;
  const c = () => {
    a !== void 0 && cancelAnimationFrame(a), a = requestAnimationFrame(() => {
      a = void 0, ye({
        applyXRange: !1,
        series: t.current,
        surface: e,
        visibleSeriesIds: i.current,
        xAxis: n.current,
        yAxis: r.current,
        yAxisSecondary: s.current
      });
    });
  };
  return o.visibleRangeChanged.subscribe(c), () => {
    a !== void 0 && cancelAnimationFrame(a), o.visibleRangeChanged.unsubscribe(c);
  };
}
function Ws(t) {
  if (t.xAxes.size() === 0)
    return;
  const e = t.xAxes.get(0).visibleRange;
  if (e)
    return {
      max: e.max,
      min: e.min
    };
}
function Ks(t) {
  const e = t.max - t.min;
  return Math.abs(e) * 0.01;
}
function Xs(t) {
  return t ? Math.abs(t.max - t.min) : Number.POSITIVE_INFINITY;
}
function Zs({
  currentRange: t,
  fullRange: e,
  threshold: i
}) {
  const n = t.max - t.min, r = e.max - e.min;
  return Math.abs(n - r) > i || Math.abs(t.min - e.min) > i || Math.abs(t.max - e.max) > i;
}
function Ys({
  surface: t,
  wasmContext: e,
  series: i,
  visibleSeriesIds: n,
  showAxisLabels: r,
  showAxisTickLabels: s,
  xAxis: o,
  xAxisRef: a,
  yAxis: c,
  yAxisRef: d,
  yAxisSecondary: l,
  yAxisSecondaryRef: u
}) {
  const f = I("--datavis-datavis-axis-lines"), h = I("--datavis-datavis-grid-lines"), b = et("bottom"), p = et("left"), m = eo(), g = to(), v = !!(l || i.some(($) => $.yAxisId === F)), y = ln({
    series: i,
    visibleSeriesIds: n
  });
  t.viewportBorder = {
    borderBottom: 1,
    borderLeft: 1,
    borderRight: y ? 1 : 0,
    color: f
  };
  const w = qi(i), R = un({
    series: i,
    xAxis: o
  }), S = Be({
    axis: c,
    axisId: W,
    series: i,
    visibleSeriesIds: n
  }), L = Be({
    axis: l,
    axisId: F,
    series: i,
    visibleSeriesIds: n
  }), k = w ? new ci(e, {
    axisAlignment: re.Bottom,
    axisTitle: r ? o?.title : void 0,
    axisTitleStyle: b,
    autoRange: z.Once,
    drawLabels: r,
    drawMajorBands: !1,
    drawMajorGridLines: !1,
    drawMajorTickLines: s,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: new N(0.02, 0.02),
    keepLabelsWithinAxis: !1,
    labelStyle: {
      ...m,
      alignment: st.Center,
      color: se(s)
    },
    majorTickLineStyle: Pe(f),
    maxAutoTicks: o?.tickCount ?? 9,
    useNativeText: !1,
    visibleRange: R
  }) : new xe(e, {
    axisAlignment: re.Bottom,
    axisTitle: r ? o?.title : void 0,
    axisTitleStyle: b,
    autoRange: z.Once,
    drawLabels: r,
    drawMajorBands: !1,
    drawMajorGridLines: !1,
    drawMajorTickLines: s,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: new N(0.02, 0.02),
    keepLabelsWithinAxis: !1,
    labelStyle: {
      ...m,
      alignment: st.Center,
      color: se(s)
    },
    majorTickLineStyle: Pe(f),
    maxAutoTicks: o?.tickCount ?? 9,
    useNativeText: !1,
    visibleRange: R
  });
  w && (k.labelProvider = new io()), Wi({
    axis: k,
    hasDateAxis: w,
    xAxisRef: a
  }), t.xAxes.add(k), t.yAxes.add(new xe(e, {
    axisAlignment: re.Left,
    id: W,
    axisTitle: r ? c?.title : void 0,
    axisTitleStyle: p,
    autoRange: S ? z.Never : z.Always,
    drawLabels: r,
    drawMajorBands: !1,
    drawMajorGridLines: !0,
    drawMajorTickLines: s,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: si(c),
    labelStyle: {
      ...g,
      color: se(s)
    },
    majorGridLineStyle: {
      color: h,
      strokeThickness: 1
    },
    majorTickLineStyle: Pe(f),
    maxAutoTicks: c?.tickCount ?? 6,
    useNativeText: !1,
    visibleRange: S
  }));
  const A = t.yAxes.get(0);
  if (dt({
    axis: A,
    axisRef: d
  }), !v)
    return;
  const _ = new xe(e, {
    axisAlignment: re.Right,
    id: F,
    axisTitle: r ? l?.title : void 0,
    axisTitleStyle: et("right"),
    autoRange: L ? z.Never : z.Always,
    drawLabels: r,
    drawMajorBands: !1,
    drawMajorGridLines: !1,
    drawMajorTickLines: s,
    drawMinorGridLines: !1,
    drawMinorTickLines: !1,
    growBy: si(l),
    labelStyle: {
      ...g,
      color: se(s)
    },
    majorTickLineStyle: Pe(f),
    maxAutoTicks: l?.tickCount ?? 6,
    isVisible: y,
    useNativeText: !1,
    visibleRange: L
  });
  dt({
    axis: _,
    axisRef: u
  }), t.yAxes.add(_);
}
function qi(t) {
  return t.some((e) => e.data.some((i) => i.x instanceof Date));
}
function Js({
  hasDateAxis: t,
  surface: e,
  xAxisRef: i,
  yAxisRef: n,
  yAxisSecondaryRef: r
}) {
  e.suspendUpdates();
  try {
    e.xAxes.size() > 0 && Wi({
      axis: e.xAxes.get(0),
      hasDateAxis: t,
      xAxisRef: i
    });
    for (let s = 0; s < e.yAxes.size(); s += 1) {
      const o = e.yAxes.get(s);
      dt({
        axis: o,
        axisRef: o.id === F ? r : n
      });
    }
  } finally {
    e.resumeUpdates({
      invalidateOnResume: !0
    });
  }
}
function Wi({
  axis: t,
  hasDateAxis: e,
  xAxisRef: i
}) {
  const n = t.labelProvider, r = Ki(n);
  n.formatLabel = (s) => {
    const o = i.current?.formatTick;
    return o?.(e ? new Date(s * 1e3) : At(s)) ?? ut(s, r);
  }, n.formatCursorLabel = (s) => e ? Ti(new Date(s * 1e3)) : ut(s, r);
}
function dt({
  axis: t,
  axisRef: e
}) {
  const i = t.labelProvider, n = Ki(i);
  i.formatLabel = (r) => e.current?.formatTick?.(At(r)) ?? ut(r, n);
}
function ut(t, e) {
  return e(At(t));
}
function At(t) {
  return Number(t.toPrecision(12));
}
function Ki(t) {
  const e = Qt.get(t);
  if (e)
    return e;
  const i = t.formatLabel?.bind(t) ?? ((n) => String(n));
  return Qt.set(t, i), i;
}
function Qs({
  showAxisLabels: t,
  showAxisTickLabels: e,
  surface: i,
  xAxis: n,
  yAxis: r,
  yAxisSecondary: s
}) {
  i.suspendUpdates();
  try {
    for (let o = 0; o < i.xAxes.size(); o += 1) {
      const a = i.xAxes.get(o);
      a.axisTitle = t ? n?.title ?? "" : "", a.drawLabels = t, a.drawMajorTickLines = e, a.labelStyle = {
        ...a.labelStyle,
        color: se(e)
      };
    }
    for (let o = 0; o < i.yAxes.size(); o += 1) {
      const a = i.yAxes.get(o), c = a.id === F ? s : r;
      a.axisTitle = t ? c?.title ?? "" : "", a.drawLabels = t, a.drawMajorTickLines = e, a.labelStyle = {
        ...a.labelStyle,
        color: se(e)
      };
    }
  } finally {
    i.resumeUpdates({
      invalidateOnResume: !0
    });
  }
}
function et(t) {
  const e = t === "bottom" ? new j(12, 0, 0, 0) : t === "left" ? new j(0, 0, 12, 0) : new j(0, 0, 0, 12);
  return {
    color: I("--text-text-default"),
    fontFamily: ke("--font-family-label"),
    fontSize: Ce("--font-size-label-large", 14),
    fontWeight: "600",
    padding: e,
    useNativeText: !1
  };
}
function eo() {
  return {
    color: I("--text-text-subtle"),
    fontFamily: ke("--font-family-body"),
    fontSize: Ce("--font-size-label-nav", 10),
    fontWeight: "400",
    multilineAlignment: He.Center,
    padding: new j(8, 2, 2, 2)
  };
}
function to() {
  return {
    color: I("--text-text-subtle"),
    fontFamily: ke("--font-family-body"),
    fontSize: Ce("--font-size-body-small", 12),
    fontWeight: "400",
    multilineAlignment: He.Center,
    padding: new j(2, 4, 2, 4)
  };
}
function se(t) {
  return t ? I("--text-text-subtle") : "rgba(0, 0, 0, 0)";
}
function ke(t) {
  return ie(t).replaceAll('"', "").trim() || "Inter";
}
function Ce(t, e) {
  const i = Number.parseFloat(ie(t));
  return Number.isFinite(i) ? i : e;
}
function Pe(t) {
  return {
    color: t,
    strokeThickness: 1,
    tickSize: 8
  };
}
class io extends mi {
  constructor() {
    super({
      useNativeText: !1
    }), this.textVariesForSameTick = !0, this.formatLabel = (e) => ki(new Date(e * 1e3), Xs(this.parentAxis?.visibleRange));
  }
}
function no({
  shadingRegions: t,
  surface: e
}) {
  t.forEach((i) => {
    const n = I(_s[i.tone]);
    if (i.axis === "x") {
      e.annotations.add(new It({
        annotationLayer: ee.Background,
        fill: n,
        isEditable: !1,
        opacity: ei(i.opacity),
        strokeThickness: 0,
        x1: M(i.from),
        x2: M(i.to),
        xCoordinateMode: D.DataValue,
        y1: 0,
        y2: 1,
        yCoordinateMode: D.Relative
      }));
      return;
    }
    e.annotations.add(new It({
      annotationLayer: ee.Background,
      fill: n,
      isEditable: !1,
      opacity: ei(i.opacity),
      strokeThickness: 0,
      x1: 0,
      x2: 1,
      xCoordinateMode: D.Relative,
      y1: i.from,
      y2: i.to,
      yAxisId: i.yAxisId === F ? F : W,
      yCoordinateMode: D.DataValue
    }));
  });
}
function ei(t) {
  return $s[t ?? "subtle"];
}
function ro({
  stripLinesRef: t,
  stripLines: e,
  surface: i
}) {
  const n = I("--text-text-subtext"), r = ke("--font-family-label"), s = Ce("--font-size-label-medium", 12);
  e.forEach((o) => {
    const a = so(o), c = fo(o), d = o.labelColor === "match" ? c : n, l = ji[o.lineStyle ?? "solid"], u = o.onDrag !== void 0, f = u ? [di.Body] : [];
    if (o.axis === "x") {
      const p = M(o.value), m = new ui({
        annotationLayer: a,
        dragPoints: f,
        id: en(o.id),
        isEditable: u,
        selectionBoxDelta: -1,
        selectionBoxStroke: "transparent",
        selectionBoxThickness: 0,
        showLabel: !1,
        stroke: c,
        strokeDashArray: l,
        strokeThickness: 1,
        x1: p,
        xCoordinateMode: D.DataValue
      });
      u && m.dragDelta.subscribe(() => {
        const g = ti({
          axis: "x",
          id: o.id,
          stripLinesRef: t
        });
        g?.onDrag?.(g.value instanceof Date ? new Date(m.x1 * 1e3) : m.x1);
      }), i.annotations.add(m), o.label && i.annotations.add(new Ae({
        annotationLayer: a,
        horizontalAnchorPoint: we.Left,
        id: Qi(o.id),
        isEditable: !1,
        svgString: ii({
          color: d,
          fontFamily: r,
          fontSize: s,
          rotation: Gi,
          text: o.label
        }),
        verticalAnchorPoint: te.Top,
        x1: p,
        xCoordinateMode: D.DataValue,
        xCoordShift: zs,
        y1: Os,
        yCoordShift: Fs,
        yCoordinateMode: D.Relative
      }));
      return;
    }
    const h = o.yAxis === "secondary" ? F : W, b = new fi({
      annotationLayer: a,
      dragPoints: f,
      id: Ji(o.id),
      isEditable: u,
      selectionBoxDelta: -1,
      selectionBoxStroke: "transparent",
      selectionBoxThickness: 0,
      showLabel: !1,
      stroke: c,
      strokeDashArray: l,
      strokeThickness: 1,
      y1: o.value,
      yAxisId: h,
      yCoordinateMode: D.DataValue
    });
    if (u && b.dragDelta.subscribe(() => {
      ti({
        axis: "y",
        id: o.id,
        stripLinesRef: t
      })?.onDrag?.(b.y1);
    }), i.annotations.add(b), o.label) {
      const p = Zi({
        value: o.value,
        yAxis: Te(i, h)
      });
      i.annotations.add(new Ae({
        annotationLayer: a,
        id: Yi(o.id),
        horizontalAnchorPoint: we.Right,
        isEditable: !1,
        svgString: ii({
          color: d,
          fontFamily: r,
          fontSize: s,
          text: o.label
        }),
        verticalAnchorPoint: p.verticalAnchorPoint,
        x1: 1,
        xCoordinateMode: D.Relative,
        xCoordShift: Ns,
        y1: o.value,
        yAxisId: h,
        yCoordShift: p.yCoordShift,
        yCoordinateMode: D.DataValue
      }));
    }
  });
}
function so(t) {
  return t.layer === "behindData" ? ee.Background : ee.AboveChart;
}
function oo({
  stripLines: t,
  surface: e
}) {
  e.suspendUpdates();
  try {
    t.forEach((i) => {
      if (i.axis === "x") {
        Ne({
          annotationId: en(i.id),
          coordinate: "x1",
          surface: e,
          value: M(i.value)
        }), Ne({
          annotationId: Qi(i.id),
          coordinate: "x1",
          surface: e,
          value: M(i.value)
        });
        return;
      }
      Ne({
        annotationId: Ji(i.id),
        coordinate: "y1",
        surface: e,
        value: i.value
      }), Ne({
        annotationId: Yi(i.id),
        coordinate: "y1",
        surface: e,
        value: i.value
      });
    }), Xi(e);
  } finally {
    e.resumeUpdates({
      invalidateOnResume: !0
    });
  }
}
function Ne({
  annotationId: t,
  coordinate: e,
  surface: i,
  value: n
}) {
  const r = i.annotations.asArray().find((s) => s.id === t);
  r && (r[e] = n);
}
function Xi(t) {
  t.annotations.asArray().forEach((e) => {
    const i = e;
    if (!ao(i.id) || typeof i.y1 != "number")
      return;
    const n = Te(t, i.yAxisId === F ? F : W);
    if (i.isVisible = lo({
      value: i.y1,
      visibleRange: n?.visibleRange
    }), !i.id?.startsWith(vt))
      return;
    const r = i, s = Zi({
      value: i.y1,
      yAxis: n
    });
    r.verticalAnchorPoint = s.verticalAnchorPoint, r.yCoordShift = s.yCoordShift;
  });
}
function ao(t) {
  return t?.startsWith(Hi) || t?.startsWith(vt);
}
function lo({
  value: t,
  visibleRange: e
}) {
  return !!(e && t >= e.min && t <= e.max);
}
function Zi({
  value: t,
  yAxis: e
}) {
  const i = e?.visibleRange;
  return i && co(t, i) ? {
    verticalAnchorPoint: te.Top,
    yCoordShift: Jt
  } : {
    verticalAnchorPoint: te.Bottom,
    yCoordShift: -Jt
  };
}
function co(t, e) {
  const i = e.max - e.min;
  return i <= 0 ? !1 : (t - e.min) / i >= Es;
}
function Yi(t) {
  return `${vt}${t}`;
}
function Ji(t) {
  return `${Hi}${t}`;
}
function Qi(t) {
  return `${Vs}${t}`;
}
function en(t) {
  return `${Ds}${t}`;
}
function ti({
  axis: t,
  id: e,
  stripLinesRef: i
}) {
  return i.current.find((n) => n.id === e && n.axis === t);
}
function ii({
  color: t,
  fontFamily: e,
  fontSize: i,
  rotation: n = 0,
  text: r
}) {
  const s = uo({
    fontSize: i,
    text: r
  });
  if (n === Gi) {
    const d = Math.ceil(i * 1.3), l = d + 4, u = Math.ceil(s + 4);
    return `<svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="${l}" height="${u}" viewBox="0 0 ${l} ${u}">
    <text x="0" y="0" fill="${oe(t)}" font-size="${i}" font-family="${oe(e)}" font-weight="500" dominant-baseline="hanging" transform="translate(${2 + d} 2) rotate(${n})">${ft(r)}</text>
  </svg>`;
  }
  const o = Math.ceil(i * 1.4), a = Math.ceil(s);
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${a}" height="${o}" viewBox="0 0 ${a} ${o}">
    <text x="0" y="${i}" fill="${oe(t)}" font-size="${i}" font-family="${oe(e)}" font-weight="500">${ft(r)}</text>
  </svg>`;
}
function uo({
  fontSize: t,
  text: e
}) {
  return Math.max(t, e.length * t * 0.62);
}
function oe(t) {
  return t.replaceAll("&", "&amp;").replaceAll('"', "&quot;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
function ft(t) {
  return t.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
function fo(t) {
  return cn(I(t.colorToken), Ps);
}
function ho({
  surface: t,
  wasmContext: e,
  series: i,
  seriesType: n,
  visibleSeriesIds: r,
  pointMarkers: s
}) {
  const o = new Set(r), a = t.xAxes.size() > 0 ? t.xAxes.get(0).visibleRange : void 0;
  i.forEach((c) => {
    const d = new le(e, {
      dataSeriesName: c.label
    }), l = Rt(c), u = on(c);
    d.appendRange(u.map((m) => M(m.x)), u.map((m) => m.y ?? Number.NaN));
    const f = I(Ge[c.color]), h = tn(c.pointMarkers ?? s), b = h && (n === "scatter" || rn({
      markerConfig: h,
      points: l,
      visibleRange: a
    })) ? nn({
      markerConfig: h,
      seriesColor: f,
      wasmContext: e
    }) : void 0, p = {
      dataSeries: d,
      id: c.id,
      isVisible: o.has(c.id),
      pointMarker: b,
      yAxisId: Fe(c)
    };
    t.renderableSeries.add(n === "scatter" ? new ht(e, p) : new yn(e, {
      ...p,
      stroke: f,
      strokeDashArray: ji[c.lineStyle ?? "solid"],
      strokeThickness: 3
    }));
  });
}
function Fe(t) {
  return t.yAxisId === F ? F : W;
}
function tn(t) {
  if (t !== !1)
    return t === !0 ? {
      maxVisiblePoints: 300,
      mode: "always",
      size: 8,
      type: "circle"
    } : {
      maxVisiblePoints: t.maxVisiblePoints ?? 300,
      mode: t.mode ?? "always",
      size: t.size ?? 8,
      type: t.type ?? "circle"
    };
}
function nn({
  markerConfig: t,
  seriesColor: e,
  wasmContext: i
}) {
  const n = {
    fill: e,
    height: t.size,
    stroke: e,
    strokeThickness: bo(t.type),
    width: t.size
  };
  switch (t.type) {
    case "cross":
      return new vi(i, n);
    case "square":
      return new yi(i, n);
    case "triangle":
      return new xi(i, n);
    case "x":
      return new gi(i, n);
    case "circle":
      return new mt(i, n);
  }
}
function mo({
  fill: t,
  markerConfig: e,
  stroke: i,
  strokeThickness: n,
  wasmContext: r
}) {
  const s = {
    fill: t,
    height: e.size,
    stroke: i,
    strokeThickness: n,
    width: e.size
  };
  switch (e.type) {
    case "cross":
      return new vi(r, s);
    case "square":
      return new yi(r, s);
    case "triangle":
      return new xi(r, s);
    case "x":
      return new gi(r, s);
    case "circle":
      return new mt(r, s);
  }
}
function rn({
  markerConfig: t,
  points: e,
  visibleRange: i
}) {
  return t.mode === "always" ? !0 : po({
    points: e,
    visibleRange: i
  }) <= t.maxVisiblePoints;
}
function po({
  points: t,
  visibleRange: e
}) {
  return e ? t.reduce((i, n) => {
    const r = M(n.point.x);
    return r >= e.min && r <= e.max ? i + 1 : i;
  }, 0) : t.length;
}
function bo(t) {
  return t === "cross" || t === "x" ? 2 : 0;
}
function go({
  pointMarkersRef: t,
  seriesType: e,
  seriesRef: i,
  surface: n,
  wasmContext: r
}) {
  if (n.xAxes.size() === 0)
    return;
  const s = n.xAxes.get(0);
  let o;
  const a = () => {
    o !== void 0 && cancelAnimationFrame(o), o = requestAnimationFrame(() => {
      o = void 0, n.suspendUpdates();
      try {
        wt({
          pointMarkersRef: t,
          seriesType: e,
          series: i.current,
          surface: n,
          wasmContext: r
        });
      } finally {
        n.resumeUpdates({
          invalidateOnResume: !0
        });
      }
    });
  };
  return s.visibleRangeChanged.subscribe(a), a(), () => {
    o !== void 0 && cancelAnimationFrame(o), s.visibleRangeChanged.unsubscribe(a);
  };
}
function wt({
  pointMarkersRef: t,
  seriesType: e = "line",
  series: i,
  surface: n,
  wasmContext: r
}) {
  We(n);
  const s = n.xAxes.size() > 0 ? n.xAxes.get(0).visibleRange : void 0;
  for (const o of i) {
    const a = n.renderableSeries.asArray().find((u) => u.id === o.id);
    if (!a)
      continue;
    const c = tn(o.pointMarkers ?? t.current);
    if (!c) {
      a.pointMarker = void 0;
      continue;
    }
    if (!(e === "scatter" || rn({
      markerConfig: c,
      points: Rt(o),
      visibleRange: s
    })) || !r) {
      a.pointMarker = void 0;
      continue;
    }
    const l = I(Ge[o.color]);
    a.pointMarker = nn({
      markerConfig: c,
      seriesColor: l,
      wasmContext: r
    });
  }
}
function xo({
  onDataPointClickRef: t,
  seriesRef: e,
  surface: i
}) {
  i.chartModifiers.add(new So({
    onDataPointClickRef: t,
    seriesRef: e
  }));
}
const Re = "__assetwatch-hover-point__";
function sn(t) {
  return t.renderableSeries.asArray().find((e) => e.id === Re);
}
function We(t) {
  const e = sn(t);
  e && t.renderableSeries.remove(e, !0);
}
function yo({
  surface: t,
  wasmContext: e
}) {
  t.chartModifiers.add(new vo({
    wasmContext: e
  }));
}
class vo extends Si {
  type = "DataPointHoverModifier";
  wasmContext;
  hoveredPoint;
  constructor({
    wasmContext: e
  }) {
    super(), this.wasmContext = e;
  }
  modifierMouseMove(e) {
    super.modifierMouseMove(e);
    const i = this.getHitDataPoint(e);
    if (!(i && this.hoveredPoint?.dataSeries === i.dataSeries && this.hoveredPoint.index === i.index && sn(this.parentSurface))) {
      if (this.clearHoverOverlay(), !i) {
        this.parentSurface.invalidateElement();
        return;
      }
      this.hoveredPoint = i, this.setHoverOverlay(i), this.parentSurface.invalidateElement();
    }
  }
  modifierMouseLeave(e) {
    super.modifierMouseLeave(e), this.clearHoverOverlay(), this.parentSurface.invalidateElement();
  }
  clearHoverOverlay() {
    this.hoveredPoint = void 0, We(this.parentSurface);
  }
  setHoverOverlay({
    dataSeries: e,
    index: i,
    yAxisId: n
  }) {
    const r = new le(this.wasmContext, {
      dataSeriesName: ""
    });
    r.append(e.getNativeXValues().get(i), e.getNativeYValues().get(i)), this.parentSurface.renderableSeries.add(new ht(this.wasmContext, {
      dataSeries: r,
      id: Re,
      pointMarker: new mt(this.wasmContext, {
        fill: "rgba(0, 0, 0, 0)",
        height: 12,
        stroke: I("--icon-icon-main"),
        strokeThickness: 2,
        width: 12
      }),
      yAxisId: n
    }));
  }
  getHitDataPoint(e) {
    const i = e.mousePoint.x, n = e.mousePoint.y;
    for (const r of [...this.getIncludedRenderableSeries()].reverse()) {
      if (r.id === Re || r.id.startsWith(ce) || !r.isVisible)
        continue;
      const s = r.hitTestProvider.hitTestDataPoint(i, n, 10);
      if (!s.isHit)
        continue;
      const o = r.dataSeries;
      if (o instanceof le)
        return {
          dataSeries: o,
          index: s.dataSeriesIndex,
          yAxisId: r.yAxisId
        };
    }
  }
}
class So extends Si {
  type = "DataPointClickModifier";
  onDataPointClickRef;
  seriesRef;
  mouseDownPoint;
  constructor({
    onDataPointClickRef: e,
    seriesRef: i
  }) {
    super(), this.onDataPointClickRef = e, this.seriesRef = i;
  }
  modifierMouseDown(e) {
    super.modifierMouseDown(e), this.mouseDownPoint = {
      x: e.mousePoint.x,
      y: e.mousePoint.y
    };
  }
  modifierMouseUp(e) {
    super.modifierMouseUp(e);
    const i = this.mouseDownPoint;
    if (this.mouseDownPoint = void 0, !this.onDataPointClickRef.current || !i || this.isDrag(e, i))
      return;
    const n = this.getHitDataPoint(e);
    n && this.onDataPointClickRef.current({
      nativeEvent: e.nativeEvent,
      point: n.point.point,
      pointIndex: n.point.pointIndex,
      series: n.series
    });
  }
  isDrag(e, i) {
    return Math.abs(e.mousePoint.x - i.x) > 4 || Math.abs(e.mousePoint.y - i.y) > 4;
  }
  getHitDataPoint(e) {
    const i = e.mousePoint.x, n = e.mousePoint.y;
    for (const r of [...this.getIncludedRenderableSeries()].reverse()) {
      if (r.id === Re || r.id.startsWith(ce) || !r.isVisible)
        continue;
      const s = r.hitTestProvider.hitTestDataPoint(i, n, 14);
      if (!s.isHit)
        continue;
      const o = this.seriesRef.current.find((c) => c.id === r.id), a = o ? Ao(o, s.dataSeriesIndex) : void 0;
      if (o && a)
        return {
          point: a,
          series: o
        };
    }
  }
}
function on(t) {
  return t.data;
}
function Rt(t) {
  return t.data.flatMap((e, i) => e.y === null ? [] : [{
    point: {
      ...e,
      y: e.y
    },
    pointIndex: i
  }]);
}
function Ao(t, e) {
  const i = t.data[e];
  if (!(!i || i.y === null))
    return {
      point: {
        ...i,
        y: i.y
      },
      pointIndex: e
    };
}
const ce = "__assetwatch-point-annotation__", an = "__assetwatch-point-annotation-label__";
function wo(t, e) {
  return `${ce}${t}:${e}`;
}
function Ro(t, e) {
  return `${an}${t}:${e}`;
}
function To(t) {
  return t.startsWith(ce) ? t.slice(ce.length).split(":")[0] : void 0;
}
function Ee({
  getPointKeyRef: t,
  pointAnnotations: e,
  series: i,
  surface: n,
  visibleSeriesIds: r,
  wasmContext: s
}) {
  if (!n || !s)
    return;
  const o = n.renderableSeries.asArray().filter((l) => l.id.startsWith(ce)), a = n.annotations.asArray().filter((l) => l.id.startsWith(an));
  for (const l of o)
    n.renderableSeries.remove(l, !0);
  for (const l of a)
    n.annotations.remove(l, !0);
  if (e.length === 0)
    return;
  const c = Co(e), d = new Set(r);
  for (const l of i) {
    const u = c.get(l.id);
    if (!u || u.length === 0)
      continue;
    const f = Mo({
      getPointKey: t.current,
      points: Rt(l),
      series: l
    });
    for (const h of u) {
      const b = f.get(h.pointKey);
      if (!b)
        continue;
      const p = new le(s, {
        dataSeriesName: ""
      });
      p.append(M(b.point.x), b.point.y);
      const m = Lo(h.marker);
      n.renderableSeries.add(new ht(s, {
        dataSeries: p,
        id: wo(l.id, h.pointKey),
        isVisible: d.has(l.id),
        pointMarker: mo({
          fill: ni({
            paint: m.fill,
            series: l
          }),
          markerConfig: {
            size: m.size,
            type: m.type
          },
          stroke: ni({
            paint: m.stroke,
            series: l
          }),
          strokeThickness: m.strokeWidth,
          wasmContext: s
        }),
        yAxisId: Fe(l)
      })), h.label?.value && d.has(l.id) && n.annotations.add(new Ae({
        annotationLayer: ee.AboveChart,
        horizontalAnchorPoint: we.Left,
        id: Ro(l.id, h.pointKey),
        isEditable: !1,
        svgString: ko({
          color: I("--text-text-default"),
          fontFamily: ke("--font-family-label"),
          fontSize: Ce("--font-size-label-medium", 12),
          text: On(b.point.y, l)
        }),
        verticalAnchorPoint: te.Bottom,
        x1: M(b.point.x),
        xCoordinateMode: D.DataValue,
        xCoordShift: m.size / 2 + 4,
        y1: b.point.y,
        yAxisId: Fe(l),
        yCoordinateMode: D.DataValue,
        yCoordShift: -(m.size / 2 + 4)
      }));
    }
  }
}
function ko({
  color: t,
  fontFamily: e,
  fontSize: i,
  text: n
}) {
  return `<svg xmlns="http://www.w3.org/2000/svg" overflow="visible">
    <text x="0" y="${i}" fill="${oe(t)}" font-size="${i}" font-family="${oe(e)}" font-weight="600">${ft(n)}</text>
  </svg>`;
}
function Co(t) {
  const e = /* @__PURE__ */ new Map();
  for (const i of t) {
    const n = e.get(i.seriesId) ?? [];
    n.push(i), e.set(i.seriesId, n);
  }
  return e;
}
function Io({
  getPointKey: t,
  point: e,
  series: i
}) {
  return t?.(e.point, e.pointIndex, i) ?? e.point.id ?? String(M(e.point.x));
}
function Mo({
  getPointKey: t,
  points: e,
  series: i
}) {
  const n = /* @__PURE__ */ new Map();
  for (const r of e)
    n.set(Io({
      getPointKey: t,
      point: r,
      series: i
    }), r);
  return n;
}
function Lo(t) {
  return {
    fill: t?.fill ?? "surface",
    size: t?.size ?? 12,
    stroke: t?.stroke ?? "series",
    strokeWidth: t?.strokeWidth ?? 2,
    type: t?.type ?? "circle"
  };
}
function ni({
  paint: t,
  series: e
}) {
  return I(t === "series" ? Ge[e.color] : t === "surface" ? "--surface-surface" : t === "inverse" ? "--surface-inverse-surface" : t);
}
function _o({
  getPointKeyRef: t,
  pointAnnotations: e,
  pointMarkersRef: i,
  seriesType: n,
  series: r,
  surface: s,
  visibleSeriesIds: o,
  wasmContext: a
}) {
  if (s) {
    s.suspendUpdates();
    try {
      We(s);
      for (const c of r) {
        const d = s.renderableSeries.asArray().find((u) => u.id === c.id);
        if (!d)
          continue;
        const l = d.dataSeries;
        l instanceof le && $o({
          dataSeries: l,
          series: c
        });
      }
      wt({
        pointMarkersRef: i,
        seriesType: n,
        series: r,
        surface: s,
        wasmContext: a
      }), Ee({
        getPointKeyRef: t,
        pointAnnotations: e,
        series: r,
        surface: s,
        visibleSeriesIds: o,
        wasmContext: a
      });
    } finally {
      s.resumeUpdates({
        invalidateOnResume: !0
      });
    }
  }
}
function $o({
  dataSeries: t,
  series: e
}) {
  const i = on(e);
  t.clear(), t.appendRange(i.map((n) => M(n.x)), i.map((n) => n.y ?? Number.NaN));
}
function Po({
  series: t,
  surface: e,
  visibleSeriesIds: i
}) {
  if (!e)
    return;
  const n = new Set(i);
  e.suspendUpdates();
  try {
    e.renderableSeries.asArray().forEach((r) => {
      if (r.id === Re)
        return;
      const s = To(r.id);
      r.isVisible = n.has(s ?? r.id);
    }), No({
      series: t,
      surface: e,
      visibleSeriesIds: i
    });
  } finally {
    e.resumeUpdates({
      invalidateOnResume: !0
    });
  }
}
function No({
  series: t,
  surface: e,
  visibleSeriesIds: i
}) {
  const n = Te(e, F);
  if (!n)
    return;
  const r = ln({
    series: t,
    visibleSeriesIds: i
  });
  n.isVisible = r, e.viewportBorder = {
    ...e.viewportBorder,
    borderRight: r ? 1 : 0
  };
}
function ln({
  series: t,
  visibleSeriesIds: e
}) {
  const i = new Set(e);
  return t.some((n) => n.yAxisId === F && i.has(n.id) && n.data.some((r) => r.y !== null));
}
function ye({
  applyXRange: t = !0,
  onControlledRangeApplied: e,
  pointMarkersRef: i,
  seriesType: n,
  series: r,
  surface: s,
  visibleSeriesIds: o,
  wasmContext: a,
  xAxis: c,
  yAxis: d,
  yAxisSecondary: l
}) {
  if (!s)
    return;
  const u = s.xAxes.get(0), f = Te(s, W), h = Te(s, F), b = un({
    series: r,
    xAxis: c
  }), p = t ? b ?? u.visibleRange : u.visibleRange, m = Be({
    axis: d,
    axisId: W,
    series: r,
    visibleSeriesIds: o,
    xRange: p
  }), g = Be({
    axis: l,
    axisId: F,
    series: r,
    visibleSeriesIds: o,
    xRange: p
  }), v = !!(c?.visibleRange || d?.visibleRange || l?.visibleRange);
  let y = !1;
  s.suspendUpdates();
  try {
    We(s), t && b && !tt(u.visibleRange, b) && (u.autoRange = z.Never, u.visibleRange = b, y = !0), f && m && !tt(f.visibleRange, m) ? (f.autoRange = z.Never, f.visibleRange = m, y = !0) : f && !m && f.autoRange !== z.Always && (f.autoRange = z.Always, y = !0), h && g && !tt(h.visibleRange, g) ? (h.autoRange = z.Never, h.visibleRange = g, y = !0) : h && !g && h.autoRange !== z.Always && (h.autoRange = z.Always, y = !0), i && wt({
      pointMarkersRef: i,
      seriesType: n,
      series: r,
      surface: s,
      wasmContext: a
    }), Xi(s);
  } finally {
    s.resumeUpdates({
      invalidateOnResume: y
    });
  }
  v && y && e?.();
}
function ri({
  series: t,
  surface: e,
  visibleSeriesIds: i,
  xAxis: n,
  yAxis: r,
  yAxisSecondary: s,
  zoomCallbacksRef: o
}) {
  ye({
    onControlledRangeApplied: () => {
      o.current.onZoomStateChange?.(!1);
    },
    pointMarkersRef: void 0,
    series: t,
    surface: e,
    visibleSeriesIds: i,
    xAxis: n,
    yAxis: r,
    yAxisSecondary: s
  });
}
function Te(t, e) {
  return t.yAxes.asArray().find((i) => i.id === e);
}
function tt(t, e) {
  return t !== void 0 && t.min === e.min && t.max === e.max;
}
function Eo({
  surface: t,
  series: e,
  pointMarkers: i,
  tooltipRef: n
}) {
  const r = I("--datavis-datavis-axis-lines"), s = I("--datavis-datavis-tooltip-bg"), o = I("--datavis-datavis-bg-datehover"), a = I("--text-text-default-inverse");
  t.chartModifiers.add(new hi({
    axisLabelFill: s,
    axisLabelCornerRadius: 2,
    axisLabelPadding: new j(4, 4, 4, 4),
    axisLabelStroke: r,
    crosshairStroke: r,
    crosshairStrokeThickness: 1,
    showAxisLabels: !0,
    showTooltip: !0,
    showXLine: !0,
    showYLine: !1,
    tooltipContainerBackground: s,
    tooltipSvgTemplate: Mi({
      chartPointMarkers: i,
      series: e,
      tooltipRef: n
    }),
    tooltipTextStroke: r,
    xAxisLabelFill: o,
    xAxisLabelStroke: a,
    yAxisLabelFill: "transparent",
    yAxisLabelStroke: "transparent"
  }));
}
function Do({
  onZoomExtents: t,
  surface: e,
  zoomConfig: i
}) {
  if (!i.enabled)
    return;
  const n = Fo(i.direction);
  if (i.wheel && e.chartModifiers.add(new vn({
    xyDirection: n
  })), i.select) {
    const r = I("--primary-primary"), s = new pi({
      fill: cn(r, 0.14),
      modifierGroup: i.syncGroup,
      stroke: r,
      strokeThickness: 1,
      xyDirection: n
    });
    s.isEnabled = i.interactionMode === "zoom", e.chartModifiers.add(s);
  }
  if (i.pan) {
    const r = new bi({
      modifierGroup: i.syncGroup,
      xyDirection: n
    });
    r.isEnabled = !i.select || i.interactionMode === "pan", e.chartModifiers.add(r);
  }
  i.zoomExtents && e.chartModifiers.add(new Sn({
    isAnimated: !0,
    modifierGroup: i.syncGroup,
    onZoomExtents: t,
    xyDirection: n
  }));
}
function Vo({
  surface: t,
  zoomConfig: e
}) {
  if (!(!t || !e.enabled)) {
    t.suspendUpdates();
    try {
      t.chartModifiers.asArray().forEach((i) => {
        i instanceof pi && (i.isEnabled = e.select && e.interactionMode === "zoom"), i instanceof bi && (i.isEnabled = e.pan && (!e.select || e.interactionMode === "pan"));
      });
    } finally {
      t.resumeUpdates({
        invalidateOnResume: !1
      });
    }
  }
}
function cn(t, e) {
  if (/^#[\da-f]{6}$/i.test(t)) {
    const i = Number.parseInt(t.slice(1, 3), 16), n = Number.parseInt(t.slice(3, 5), 16), r = Number.parseInt(t.slice(5, 7), 16);
    return `rgba(${i}, ${n}, ${r}, ${e})`;
  }
  if (/^#[\da-f]{3}$/i.test(t)) {
    const i = Number.parseInt(t[1] + t[1], 16), n = Number.parseInt(t[2] + t[2], 16), r = Number.parseInt(t[3] + t[3], 16);
    return `rgba(${i}, ${n}, ${r}, ${e})`;
  }
  return t.startsWith("hsl(") ? t.replace("hsl(", "hsla(").replace(")", ` / ${e})`) : t.startsWith("rgb(") ? t.replace("rgb(", "rgba(").replace(")", `, ${e})`) : t;
}
function zo(t) {
  return t === !0 ? it : t ? {
    ...it,
    ...t,
    enabled: t.enabled ?? !0
  } : {
    ...it,
    enabled: !1
  };
}
const it = {
  direction: "x",
  enabled: !0,
  interactionMode: "zoom",
  pan: !0,
  select: !0,
  wheel: !1,
  zoomExtents: !0
};
function Fo(t) {
  return t === "y" ? Xe.YDirection : t === "xy" ? Xe.XyDirection : Xe.XDirection;
}
function Oe(t, e) {
  if (t.length === 0)
    return;
  const i = Math.min(...t), n = Math.max(...t);
  if (i === n)
    return new N(i - 1, n + 1);
  const r = n - i, s = r * (e?.minGrowBy ?? 0), o = r * (e?.maxGrowBy ?? 0);
  return new N(i - s, n + o);
}
function dn(t, e) {
  if (!t?.visibleRange)
    return;
  const i = Oe([M(t.visibleRange.min), M(t.visibleRange.max)], {
    maxGrowBy: 0.02,
    minGrowBy: 0.02
  });
  return e?.axisType === "y" && t.baseline === "zero" && i && i.min < 0 && M(t.visibleRange.min) >= 0 ? new N(0, i.max) : i;
}
function Be({
  axis: t,
  axisId: e,
  series: i,
  visibleSeriesIds: n,
  xRange: r
}) {
  const s = dn(t, {
    axisType: "y"
  });
  if (s)
    return s;
  const o = Oo({
    axisId: e,
    series: i,
    visibleSeriesIds: n,
    xRange: r
  });
  if (o.length !== 0) {
    if (t?.baseline === "zero" && o.every((a) => a >= 0)) {
      const a = Oe(o, {
        maxGrowBy: 0.2,
        minGrowBy: 0.12
      });
      return a ? a.max === 0 ? new N(0, 1) : new N(Math.max(0, a.min), a.max) : void 0;
    }
    return Oe(o, {
      maxGrowBy: 0.2,
      minGrowBy: 0.12
    });
  }
}
function Oo({
  axisId: t,
  series: e,
  visibleSeriesIds: i,
  xRange: n
}) {
  const r = new Set(i);
  return e.filter((s) => Fe(s) === t && r.has(s.id)).flatMap((s) => s.data).filter((s) => {
    if (s.y === null)
      return !1;
    if (!n)
      return !0;
    const o = M(s.x);
    return o >= n.min && o <= n.max;
  }).map((s) => s.y).filter((s) => s !== null);
}
function un({
  series: t,
  xAxis: e
}) {
  const i = t.flatMap((n) => n.data.map((r) => M(r.x)));
  return dn(e) ?? Oe(i, {
    maxGrowBy: 0.02,
    minGrowBy: 0.02
  });
}
function si(t) {
  return t?.baseline === "zero" ? new N(0, 0.2) : new N(0.12, 0.2);
}
function Bo(t) {
  return {
    axes: [nt(t.xAxis), nt(t.yAxis), nt(t.yAxisSecondary)].join("|"),
    pointMarkers: fn(t.pointMarkers),
    shadingRegions: Xo(t.shadingRegions),
    series: Go(t.series),
    seriesType: t.seriesType,
    stripLines: Zo(t.stripLines),
    tooltip: Ko(t.tooltip),
    zoom: qo(t.zoomConfig)
  };
}
function De(t) {
  return {
    axisFormatters: {
      x: t.xAxis?.formatTick,
      y: t.yAxis?.formatTick,
      ySecondary: t.yAxisSecondary?.formatTick
    },
    axisVisibleRanges: [rt(t.xAxis), rt(t.yAxis), rt(t.yAxisSecondary)].join("|"),
    getPointKey: t.getPointKey,
    pointAnnotations: Jo(t.pointAnnotations),
    seriesData: jo(t.series),
    showAxisLabels: String(t.showAxisLabels),
    showAxisTickLabels: String(t.showAxisTickLabels),
    stripLines: Yo(t.stripLines),
    visibleSeries: Uo(t.visibleSeriesIds),
    zoomInteractionMode: Wo(t.zoomConfig)
  };
}
function Ho(t, e) {
  return t.x !== e.x || t.y !== e.y || t.ySecondary !== e.ySecondary;
}
function Go(t) {
  return t.map((e) => [e.id, e.label, e.color, e.valueUnit ?? "", e.yAxisId ?? W, e.initiallyVisible === !1 ? "hidden" : "visible", e.lineStyle ?? "solid", fn(e.pointMarkers)].join("|")).join("");
}
function jo(t) {
  return t.map((e) => {
    const i = e.data.map((n) => {
      const r = n.y === null ? "null" : String(n.y);
      return `${n.id ?? ""},${M(n.x)},${r}`;
    }).join(";");
    return [e.id, i].join("|");
  }).join("");
}
function Uo(t) {
  return t.join("|");
}
function qo(t) {
  return [t.direction, t.enabled, t.syncGroup ?? "", t.pan, t.select, t.wheel, t.zoomExtents].join(":");
}
function Wo(t) {
  return [t.enabled, t.interactionMode, t.pan, t.select].join(":");
}
function fn(t) {
  return t === void 0 ? "" : typeof t == "boolean" ? String(t) : [t.type ?? "", t.size ?? "", t.mode ?? "", t.maxVisiblePoints ?? ""].join(":");
}
function Ko(t) {
  return t ? "enabled" : "";
}
function Xo(t) {
  return t.map((e) => [e.id, e.axis, M(e.from), M(e.to), e.tone, e.opacity ?? "", e.axis === "y" ? e.yAxisId ?? W : ""].join(":")).join("|");
}
function Zo(t) {
  return t.map((e) => [e.id, e.axis, e.colorToken, e.onDrag ? "draggable" : "static", e.label, e.labelColor ?? "default", e.layer ?? "aboveData", e.lineStyle ?? "solid", e.axis === "y" ? e.yAxis ?? "main" : ""].join(":")).join("|");
}
function Yo(t) {
  return t.map((e) => [e.id, e.axis, M(e.value)].join(":")).join("|");
}
function Jo(t) {
  return t?.map((e) => [e.seriesId, e.pointKey, e.marker?.type ?? "", e.marker?.size ?? "", e.marker?.fill ?? "", e.marker?.stroke ?? "", e.marker?.strokeWidth ?? "", e.label?.value ?? ""].join(":")).join("|") ?? "";
}
function nt(t) {
  return [t?.title ?? "", t?.tickCount ?? "", t?.baseline ?? ""].join("|");
}
function rt(t) {
  return [t?.visibleRange ? M(t.visibleRange.min) : "", t?.visibleRange ? M(t.visibleRange.max) : "", t?.baseline ?? ""].join("|");
}
const Qo = 320;
function ga(t) {
  const e = E.c(28), {
    series: i,
    xAxis: n,
    yAxis: r,
    yAxisSecondary: s,
    shadingRegions: o,
    stripLines: a,
    tooltip: c,
    zoom: d,
    pointMarkers: l,
    onDataPointClick: u,
    pointAnnotations: f,
    getPointKey: h,
    visibleSeriesIds: b,
    height: p,
    emptyMessage: m,
    className: g
  } = t, v = l === void 0 ? !0 : l, y = p === void 0 ? Qo : p, w = m === void 0 ? "No data available" : m;
  let R;
  e[0] !== b || e[1] !== i ? (R = {
    series: i,
    visibleSeriesIds: b
  }, e[0] = b, e[1] = i, e[2] = R) : R = e[2];
  const {
    hasData: S,
    resolvedSeries: L,
    validationErrors: k,
    visibleSeriesIds: A
  } = xt(R);
  let _;
  e[3] !== h || e[4] !== S || e[5] !== u || e[6] !== f || e[7] !== v || e[8] !== L || e[9] !== o || e[10] !== a || e[11] !== c || e[12] !== k.length || e[13] !== A || e[14] !== n || e[15] !== r || e[16] !== s || e[17] !== d ? (_ = k.length === 0 && /* @__PURE__ */ x(Ui, { series: L, visibleSeriesIds: A, showAxisLabels: !0, showAxisTickLabels: S, xAxis: n, yAxis: r, yAxisSecondary: s, shadingRegions: o, stripLines: a, tooltip: c, zoom: d, pointMarkers: v, onDataPointClick: u, pointAnnotations: f, getPointKey: h }), e[3] = h, e[4] = S, e[5] = u, e[6] = f, e[7] = v, e[8] = L, e[9] = o, e[10] = a, e[11] = c, e[12] = k.length, e[13] = A, e[14] = n, e[15] = r, e[16] = s, e[17] = d, e[18] = _) : _ = e[18];
  let $;
  e[19] !== w || e[20] !== S || e[21] !== y || e[22] !== _ || e[23] !== k ? ($ = /* @__PURE__ */ x("div", { className: "flex flex-col gap-(--spacing-8)", children: /* @__PURE__ */ x(pt, { emptyMessage: w, hasData: S, height: y, validationErrors: k, children: _ }) }), e[19] = w, e[20] = S, e[21] = y, e[22] = _, e[23] = k, e[24] = $) : $ = e[24];
  let C;
  return e[25] !== g || e[26] !== $ ? (C = /* @__PURE__ */ x("div", { className: g, "data-chart-component": "line-chart", "data-chart-renderer": "scichart", children: $ }), e[25] = g, e[26] = $, e[27] = C) : C = e[27], C;
}
let hn = !1;
function xa({
  licenseKey: t,
  wasmBaseUrl: e = "/",
  useCommunityLicense: i = !1,
  autoFontName: n = "Arial"
} = {}) {
  i ? ge.UseCommunityLicense() : t && ge.setRuntimeLicenseKey(t), Mt.disableAspect = !1, Mt.autoFontName = n;
  const r = e.endsWith("/") ? e : `${e}/`;
  ge.configure({
    wasmUrl: `${r}scichart2d.wasm?v=${Lt}`,
    wasmNoSimdUrl: `${r}scichart2d-nosimd.wasm?v=${Lt}`
  }), hn = !0;
}
function ya() {
  return hn;
}
const ea = 320;
function va(t) {
  const e = E.c(30), {
    series: i,
    xAxis: n,
    yAxis: r,
    yAxisSecondary: s,
    shadingRegions: o,
    stripLines: a,
    tooltip: c,
    zoom: d,
    pointMarkers: l,
    onDataPointClick: u,
    pointAnnotations: f,
    getPointKey: h,
    visibleSeriesIds: b,
    height: p,
    emptyMessage: m,
    className: g
  } = t, v = l === void 0 ? !0 : l, y = p === void 0 ? ea : p, w = m === void 0 ? "No data available" : m;
  let R;
  e[0] !== b || e[1] !== i ? (R = {
    series: i,
    visibleSeriesIds: b
  }, e[0] = b, e[1] = i, e[2] = R) : R = e[2];
  const {
    hasData: S,
    resolvedSeries: L,
    validationErrors: k,
    visibleSeriesIds: A
  } = xt(R), _ = v === !1 ? !0 : v;
  let $;
  e[3] !== L ? ($ = L.map(ta), e[3] = L, e[4] = $) : $ = e[4];
  const C = $;
  let O;
  e[5] !== h || e[6] !== S || e[7] !== u || e[8] !== f || e[9] !== _ || e[10] !== C || e[11] !== o || e[12] !== a || e[13] !== c || e[14] !== k.length || e[15] !== A || e[16] !== n || e[17] !== r || e[18] !== s || e[19] !== d ? (O = k.length === 0 && /* @__PURE__ */ x(Ui, { series: C, visibleSeriesIds: A, showAxisLabels: !0, showAxisTickLabels: S, xAxis: n, yAxis: r, yAxisSecondary: s, shadingRegions: o, stripLines: a, tooltip: c, zoom: d, pointMarkers: _, onDataPointClick: u, pointAnnotations: f, getPointKey: h, seriesType: "scatter" }), e[5] = h, e[6] = S, e[7] = u, e[8] = f, e[9] = _, e[10] = C, e[11] = o, e[12] = a, e[13] = c, e[14] = k.length, e[15] = A, e[16] = n, e[17] = r, e[18] = s, e[19] = d, e[20] = O) : O = e[20];
  let U;
  e[21] !== w || e[22] !== S || e[23] !== y || e[24] !== O || e[25] !== k ? (U = /* @__PURE__ */ x("div", { className: "flex flex-col gap-(--spacing-8)", children: /* @__PURE__ */ x(pt, { emptyMessage: w, hasData: S, height: y, validationErrors: k, children: O }) }), e[21] = w, e[22] = S, e[23] = y, e[24] = O, e[25] = k, e[26] = U) : U = e[26];
  let J;
  return e[27] !== g || e[28] !== U ? (J = /* @__PURE__ */ x("div", { className: g, "data-chart-component": "scatter-chart", "data-chart-renderer": "scichart", children: U }), e[27] = g, e[28] = U, e[29] = J) : J = e[29], J;
}
function ta(t) {
  return t.pointMarkers !== !1 ? t : {
    ...t,
    pointMarkers: void 0
  };
}
function Sa(t) {
  const e = E.c(12), {
    defaultValue: i,
    options: n,
    series: r
  } = t, [s, o] = Q(i);
  let a;
  e[0] !== n || e[1] !== s ? (a = n.find((b) => b.value === s) ?? n[0], e[0] = n, e[1] = s, e[2] = a) : a = e[2];
  const c = a, d = c.value;
  let l;
  e[3] !== n ? (l = n.map(ia), e[3] = n, e[4] = l) : l = e[4];
  const u = c.subtitle;
  let f;
  e[5] !== c.days || e[6] !== r ? (f = na(r, c.days), e[5] = c.days, e[6] = r, e[7] = f) : f = e[7];
  let h;
  return e[8] !== c || e[9] !== l || e[10] !== f ? (h = {
    value: d,
    setValue: o,
    items: l,
    selectedOption: c,
    subtitle: u,
    visibleRange: f
  }, e[8] = c, e[9] = l, e[10] = f, e[11] = h) : h = e[11], h;
}
function ia(t) {
  return {
    label: t.label,
    value: t.value
  };
}
function na(t, e) {
  const i = ra(t);
  if (!i)
    return;
  const n = new Date(i);
  return n.setUTCDate(i.getUTCDate() - e + 1), {
    max: i,
    min: n
  };
}
function ra(t) {
  let e;
  for (const i of t)
    for (const n of i.data)
      n.x instanceof Date && (!e || n.x.getTime() > e.getTime()) && (e = n.x);
  return e;
}
function Aa(t) {
  const e = E.c(14);
  let i;
  e[0] !== t ? (i = t === void 0 ? {} : t, e[0] = t, e[1] = i) : i = e[1];
  const n = i;
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ new Set(), e[2] = r) : r = e[2];
  const s = ve(r), [o, a] = Q(!1), [c, d] = Q(n.defaultInteractionMode ?? "zoom"), l = n.interactionMode ?? c;
  let u;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = function() {
    for (const S of s.current)
      S();
  }, e[3] = u) : u = e[3];
  const f = u;
  let h;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = function(S) {
    d(S);
  }, e[4] = h) : h = e[4];
  const b = h;
  let p;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = function() {
    d(sa);
  }, e[5] = p) : p = e[5];
  const m = p;
  let g;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = function(S) {
    return s.current.add(S), () => {
      s.current.delete(S);
    };
  }, e[6] = g) : g = e[6];
  const v = g;
  let y;
  e[7] !== l || e[8] !== n ? (y = {
    ...n,
    interactionMode: l,
    onResetZoomReady: v,
    onZoomStateChange: a
  }, e[7] = l, e[8] = n, e[9] = y) : y = e[9];
  let w;
  return e[10] !== l || e[11] !== o || e[12] !== y ? (w = {
    interactionMode: l,
    isZoomed: o,
    resetZoom: f,
    setInteractionMode: b,
    toggleInteractionMode: m,
    zoomProps: y
  }, e[10] = l, e[11] = o, e[12] = y, e[13] = w) : w = e[13], w;
}
function sa(t) {
  return t === "pan" ? "zoom" : "pan";
}
export {
  fa as BarChart,
  Fi as ChartContainer,
  ha as ChartFrame,
  gs as ChartHeader,
  ma as ChartLegend,
  pa as ChartSkeleton,
  ba as ChartTooltip,
  ga as LineChart,
  va as ScatterChart,
  xa as configureChartsRuntime,
  H as dataVisColorTokens,
  ya as isChartsRuntimeConfigured,
  Sa as useChartRangeControls,
  Lr as useChartSeriesVisibility,
  Aa as useChartZoomControls
};
//# sourceMappingURL=index.js.map
